function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#BDEDF8;}\n\t.st1{fill:#1A87C7;}\n\t.st2{fill:#66CEEF;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M212.29,323.92c0.2-0.2,0.4-0.4,0.6-0.8c3.8-4.2,8-7.6,12.4-10.2l91.2-52.6l-6-3.6c-1.8-1-3-3-3-5.2v-8.6 l-107.8,62.2c-6.2,3.8-10,7.8-13.6,12.8l21.4,12.2C208.69,328.12,210.49,325.72,212.29,323.92z"
}), React.createElement("path", {
  className: "st0",
  d: "M584.29,105.72c0.8-0.4,1.4-0.8,2.4-1.2l-14.8-8.6c-1.4-0.6-2.8-1-4.4-1c-2.4,0-5,1-9,3l-79,45.6l19.8,11.4 L584.29,105.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M180.49,314.72l0.4,0.2c4.2-6,8.8-10.6,15.8-15.2l58.2-33.6l34.6-20l18-10.4v-1.8c0-2.2,1.2-4.2,3-5.2 l155.6-89.8c1.8-1,4.2-1,6,0l1.6,0.8l19.6-11.4l62.6-36.2c6.6-3.4,12-5.2,19.2-1.8l19.4,11.2c5.6-1.2,10.8-0.8,15.4,1.8l-32.2-18.6 c-10-4.6-17.8-1.4-24.8,2.2l-359.6,207.8c-10,6.4-15.4,13-21,22C174.09,313.92,177.49,313.32,180.49,314.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M169.09,915.92c-0.8-1-1.6-2-2.2-3.2C167.49,913.92,167.89,915.12,169.09,915.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M163.09,898.32c0.2,2.8,0.4,5.8,1.2,8.8c-0.8-3.4-1.2-7-1.2-10.4V898.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M166.09,911.32c-0.6-1.2-1-2.4-1.4-3.8C164.89,908.92,165.49,910.12,166.09,911.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M171.89,317.12c-0.2,0.4-0.4,1-0.6,1.4c0.4-0.6,0.6-1.2,0.8-1.6L171.89,317.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M166.29,330.12c-1.4,4.2-2.4,9-2.8,14.2c0.4-4.2,1-8.6,2.4-13.2C166.09,330.72,166.09,330.12,166.29,330.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M163.09,346.92v10.4c0-4.4,0-8.6,0.2-12.8C163.49,345.12,163.49,345.92,163.09,346.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M174.29,920.72c-1.6-1-2.8-2.2-3.8-3.2C171.69,918.72,172.89,919.92,174.29,920.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M199.69,305.12l107.8-62.2v-7l-18,10.4l-34.6,20l-58.2,33.6c-7,4.4-11.4,9-15.8,15.2l5.2,3 C189.69,312.72,193.49,308.92,199.69,305.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M558.69,97.72c4-2,6.8-3,9-3c1.4,0,2.8,0.4,4.4,1l14.8,8.6c-0.8,0.4-1.6,0.8-2.4,1.2c3.4-2,6.6-3,10-3.8 l-19.4-11.2c-7-3.4-12.6-1.6-19.2,1.8l-62.6,36.2l-19.6,11.4l6,3.4L558.69,97.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M212.29,323.92c0.2-0.2,0.4-0.4,0.6-0.8C212.49,323.32,212.49,323.72,212.29,323.92z"
}), React.createElement("polygon", {
  className: "st0",
  points: "460.49,229.32 460.49,213.12 371.09,264.52 371.09,280.72 389.29,270.12  "
}), React.createElement("path", {
  className: "st0",
  d: "M509.09,163.92v37.2l65.6-38c1.8-1,4.2-1,6,0c2,1,3,3,3,5.2v288.4c8-7.4,16.4-14.2,24.8-20.6v-309.8 c0-6-1.8-10.4-4.8-12.2c-0.2,0-0.4-0.2-0.6-0.2c-1-0.4-2-0.6-3-0.8c-0.2,0-0.6,0-1,0c-1,0-2,0.2-3.2,0.6c-0.4,0-0.6,0.2-1,0.2 c-1,0.4-2.2,0.8-3.2,1.4c-0.6,0.2-0.8,0.4-1.4,0.6l-81.4,47C509.09,163.32,509.09,163.72,509.09,163.92z"
}), React.createElement("path", {
  className: "st0",
  d: "M253.69,887.12c-1,0.6-2,0.8-3,0.8s-2-0.2-3-0.8c-2-1-3-3-3-5.2v-525c0-2.2,1.2-4.2,3-5.2l74.6-43.2v-38 l-91.2,52.6c-2,1.2-3.8,2.6-5.4,3.8c-0.4,0.4-0.8,0.8-1.4,1.2c-1,0.8-2,1.8-2.8,2.6s-1.4,1.8-2.2,2.6c-1.8,2.2-3.6,4.8-5.4,7.6 c-1.2,1.8-2,3.8-3,5.8c-0.4,1-0.8,2-1.2,3c-0.6,1.6-1.2,3.2-1.6,4.8c-0.2,0.4-0.2,1-0.4,1.4c-1.2,5.6-1.2,10.8-1.2,16.8v101.4 v434.6v6.8c0,2,0.2,4,0.6,5.6c0,0.2,0.2,0.4,0.2,0.6c0.2,1.2,0.8,2.2,1.2,3.2l0.2,0.2c0,0.2,0.2,0.2,0.2,0.4c0.6,1,1.6,1.8,2.6,2.6 c3.2,1.6,7.8,1,13-2l245.4-141.6c-2.4-6.4-4.6-12.8-6.2-19.6L253.69,887.12z"
}), React.createElement("path", {
  className: "st0",
  d: "M590.49,115.92l-0.2,0.2c0.6-0.2,1-0.4,1.4-0.6C591.49,115.72,591.09,115.72,590.49,115.92z"
}), React.createElement("path", {
  className: "st0",
  d: "M214.29,341.32c1.8-2.8,3.4-5.4,5.4-7.6C217.89,336.32,216.09,338.72,214.29,341.32L214.29,341.32 L214.29,341.32z"
}), React.createElement("path", {
  className: "st0",
  d: "M209.29,925.72c0,0.2,0.2,0.2,0.2,0.4l0,0C209.69,925.92,209.69,925.72,209.29,925.72z"
}), React.createElement("path", {
  className: "st0",
  d: "M221.69,331.32c0.8-1,1.8-1.8,2.8-2.6C223.69,329.52,222.89,330.12,221.69,331.32z"
}), React.createElement("path", {
  className: "st0",
  d: "M231.29,323.32c-1.8,1-3.6,2.4-5.4,3.8C227.49,325.92,229.29,324.52,231.29,323.32z"
}), React.createElement("path", {
  className: "st0",
  d: "M211.29,347.52c0,0.2-0.2,0.2-0.2,0.4c-0.4,0.8-0.6,1.8-1,2.6l0,0C210.49,349.32,211.09,348.32,211.29,347.52z "
}), React.createElement("path", {
  className: "st0",
  d: "M208.69,355.12c0,0.2-0.2,0.4-0.2,0.4c0,0.2-0.2,0.4-0.2,0.6s0,0.2,0,0.4 C208.69,355.92,208.69,355.72,208.69,355.12z"
}), React.createElement("path", {
  className: "st0",
  d: "M603.69,114.32c-0.2,0-0.4,0-0.6-0.2C603.49,113.92,603.69,114.32,603.69,114.32 C603.9,114.32,603.9,114.32,603.69,114.32z"
}), React.createElement("path", {
  className: "st0",
  d: "M595.09,113.92c0.4-0.2,0.6-0.2,1-0.2C595.49,113.92,595.29,113.92,595.09,113.92z"
}), React.createElement("path", {
  className: "st0",
  d: "M599.69,113.32c-0.2,0-0.4,0-0.4,0c0.4,0,0.6,0,1,0C599.89,113.32,599.89,113.32,599.69,113.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M611.89,111.52c-0.2,0.6-0.6,1-1.2,1.4c2.4,3.2,3.8,7.8,3.8,13.4v305.4c2-1.4,4-2.8,6-4.2v-301.2 c0-10.6-3.8-18.6-11-22.8C612.7,105.12,613.69,108.92,611.89,111.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M228.09,931.92c-4.8,2.8-9.4,3.8-13.4,3.4c-0.2,0.6-0.4,1.2-0.6,1.6c-1.2,1.8-3.2,2.8-5.2,2.8 c-1,0-2-0.2-3-0.8c3,1.8,6.4,2.6,10,2.6c4.8,0,9.8-1.4,15.2-4.4l244.4-141c-1-1.8-1.8-3.6-2.8-5.4L228.09,931.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M212.29,323.92c-1.8,2-3.4,4-5,6.2l0,0C208.69,328.12,210.49,325.92,212.29,323.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M316.29,260.12L316.29,260.12l-91.2,52.6c-4.4,2.6-8.6,6.2-12.4,10.2c3.4-3.6,7.2-7,12.2-10.2L316.29,260.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M499.29,154.72l85.2-49.2L499.29,154.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M214.29,937.12c0.4-0.6,0.4-1,0.6-1.6l0,0C214.89,936.32,214.49,936.72,214.29,937.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M215.49,329.52c0.8-0.8,1.4-1.8,2.2-2.6C216.69,327.72,216.09,328.92,215.49,329.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M594.29,101.92l12.4,7h-0.2c1.8,1,3.2,2.4,4.4,4.2c0.4-0.4,0.8-0.8,1.2-1.4c1.4-2.8,0.4-6.4-2.4-8 C605.29,100.92,600.09,100.72,594.29,101.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M600.29,107.12c0.4,0,1,0,1.4,0C601.49,107.12,601.09,107.52,600.29,107.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M587.7,110.72c1.6-1,3.4-1.6,5-2.2C590.69,109.32,589.09,109.92,587.7,110.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M594.49,107.72c1-0.2,2-0.6,3-0.6C596.49,107.52,595.49,107.52,594.49,107.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M499.29,154.72l6,3.4l19.6-11.4l62.6-36c1.8-0.8,3.4-1.6,5-2.2c0.8-0.2,1.4-0.4,2.2-0.6c1-0.2,2-0.6,3-0.6 c1-0.2,2,0,2.8,0c0.4,0,1,0,1.4,0c1.6,0.2,3.2,0.6,4.6,1.4h0.2l-12.4-7c-3.2,0.6-6.6,1.8-10,3.8L499.29,154.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M212.29,333.12c0.2,0,0.2,0.2,0.2,0.2c1-1.2,1.8-2.4,2.8-3.6c0.8-0.8,1.4-1.8,2.2-2.6c3.2-3.6,7-6.6,10.8-8.8 l58.2-33.6l34.6-20l1.4-0.8l-6-3.4l-91.4,52.8c-5,3.2-9,6.4-12.2,10.2c-0.2,0.2-0.4,0.4-0.6,0.8c-1.8,2-3.4,4-4.8,6.2 L212.29,333.12z"
}), React.createElement("polygon", {
  className: "st1",
  points: "590.29,116.32 590.29,116.32 508.69,163.32 508.69,163.32  "
}), React.createElement("path", {
  className: "st1",
  d: "M600.09,113.32c1.2,0,2.2,0.4,3,0.8C602.29,113.72,601.09,113.32,600.09,113.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M596.09,113.92c1.2-0.4,2.2-0.6,3.2-0.6C598.09,113.32,596.89,113.32,596.09,113.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M604.09,114.52c-0.2,0-0.2,0-0.4-0.2c3,1.8,4.8,6.2,4.8,12.2v309.8c2-1.4,4-2.8,6-4.4v-305.6 c0-5.6-1.4-10.2-3.8-13.4C609.09,114.72,606.49,115.32,604.09,114.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M219.69,333.92c0.8-0.8,1.4-1.8,2.2-2.6C221.09,331.92,220.49,333.12,219.69,333.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M207.89,921.72L207.89,921.72c0,0.2,0,0.4,0.2,0.6c0,0,0,0,0,0.2C207.89,922.12,207.89,921.92,207.89,921.72z"
}), React.createElement("polygon", {
  className: "st1",
  points: "231.29,323.32 322.49,270.72 322.49,270.72  "
}), React.createElement("path", {
  className: "st1",
  d: "M209.29,925.52L209.29,925.52L209.29,925.52L209.29,925.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M226.09,327.12c-0.4,0.4-0.8,0.8-1.4,1.2C225.09,328.32,225.49,327.72,226.09,327.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M225.09,926.72c-5,3-9.8,3.6-13,2l0.2,0.2l0,0l0,0l0,0c0.6,0.4,1.2,1,1.6,1.6c0.2,0.4,0.2,0.8,0.4,1 c0.2,0.4,0.4,0.6,0.4,1c0.2,1,0,1.8-0.2,2.8c4,0.4,8.6-0.6,13.4-3.4l244.6-141.2c-0.8-1.8-1.6-3.8-2.4-5.6L225.09,926.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M591.69,115.32c1-0.6,2.2-1,3.2-1.4C593.9,114.52,592.89,114.72,591.69,115.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M212.49,929.12L212.49,929.12L212.49,929.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M209.29,925.52c0.2,0.2,0.2,0.4,0.4,0.6C209.69,925.92,209.29,925.72,209.29,925.52L209.29,925.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M214.29,930.52c0.2,0.4,0.2,0.8,0.4,1C214.29,931.52,214.29,930.92,214.29,930.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M600.29,107.12c-1,0-2-0.2-2.8,0c-1,0.2-2,0.4-3,0.6c-0.8,0.2-1.4,0.4-2.2,0.6c-1.6,0.6-3.2,1.2-5,2.2 l-62.6,36l-19.6,11.4l0.8,0.4c1.6,1,2.6,2.6,2.8,4.6l81.4-47l0,0l0.2-0.2c0.4-0.2,0.8-0.4,1.2-0.6c1.2-0.6,2.2-1,3.2-1.4 c0.4-0.2,0.6-0.2,1-0.2c1.2-0.4,2.2-0.6,3.2-0.6c0.2,0,0.4,0,0.4,0c0.2,0,0.2,0,0.4,0.2c1,0,2,0.4,3,0.8c0.2,0,0.4,0,0.6,0.2 c0,0,0,0,0.2,0s0.2,0,0.4,0.2c2.4,1.2,5,0.6,6.8-1.2c-1.2-1.8-2.8-3.2-4.4-4.2c-1.6-0.8-3.2-1.2-4.6-1.4 C601.49,107.12,601.09,107.12,600.29,107.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M207.89,921.92L207.89,921.92L207.89,921.92C207.89,921.72,207.89,921.92,207.89,921.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M207.29,915.92v-6.8C207.29,911.72,207.29,913.92,207.29,915.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M221.69,331.32c0.8-1,1.8-1.8,2.8-2.6c0.4-0.4,0.8-0.8,1.4-1.2c1.8-1.4,3.4-2.8,5.4-3.8l91.2-52.6v-7l0,0 l-1.4,0.8l-34.6,20l-58.2,33.6c-4.4,2.8-7.8,5.6-10.8,8.8c-0.8,0.8-1.4,1.8-2.2,2.6c-1,1.2-2,2.4-2.8,3.6c1.2,0.8,2.2,2,2.6,3.6 c0.4,1.6,0.2,3.2-0.6,4.6c1.6-2.6,3.4-5.2,5.2-7.6C220.49,333.12,221.09,331.92,221.69,331.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M214.89,932.92c0.2,1,0,1.8-0.2,2.8l0,0C215.09,934.52,215.09,933.72,214.89,932.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M210.09,350.12c0.4-0.8,0.6-1.8,1-2.6C211.09,348.32,210.49,349.52,210.09,350.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M208.49,355.92v0.2c0-0.2,0-0.4,0.2-0.6C208.69,355.72,208.69,355.72,208.49,355.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M597.7,107.12c1-0.2,1.8,0,2.8,0C599.29,107.12,598.69,107.12,597.7,107.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M212.49,333.32L212.49,333.32c1-1.2,2-2.4,2.8-3.6C214.29,330.72,213.49,331.92,212.49,333.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M592.49,108.32c0.8-0.2,1.4-0.4,2.2-0.6C593.9,108.12,593.09,108.32,592.49,108.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M606.49,108.92c-1.4-0.8-3-1.2-4.6-1.4C603.49,107.52,604.89,108.12,606.49,108.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M217.49,326.92c3-3.2,6.4-6,10.8-8.8C224.29,320.32,220.69,323.32,217.49,326.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M250.69,881.92v-525c23.8-13.8,47.8-27.6,71.6-41.4v-7l-74.6,43.2c-2,1-3,3-3,5.2v524.8c0,2.2,1.2,4.2,3,5.2 c1,0.6,2,0.8,3,0.8s2.2-0.2,3-0.8l210.6-121.6c-0.4-2-1-4.2-1.4-6.2L250.69,881.92z"
}), React.createElement("polygon", {
  className: "st1",
  points: "389.29,270.12 460.49,229.32 460.49,229.32  "
}), React.createElement("path", {
  className: "st1",
  d: "M577.7,168.32v294.2c2-2,4-3.8,6-5.8v-288.4c0-2.2-1.2-4.2-3-5.2c-1.8-1-4.2-1-6,0l-65.6,38v7 C531.89,194.72,554.89,181.52,577.7,168.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M571.49,178.92v289.6c2-2,4-4,6-6v-294c-22.8,13.2-45.8,26.4-68.6,39.6v7L571.49,178.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M256.69,871.52v-510.8l65.6-37.8v-7.2c-23.8,13.8-47.8,27.6-71.6,41.4v524.8l212.4-122.6 c-0.4-2.2-0.8-4.2-1.2-6.4L256.69,871.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M506.09,169.32l-3,1.8v33.6l6-3.4v-37.2C509.09,165.92,507.89,168.12,506.09,169.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M371.09,264.52l89.2-51.4v-7c-31.8,18.4-63.4,36.6-95.2,55c0,8.2,0,15.8,0,23l6-3.4 C371.09,280.72,371.09,264.52,371.09,264.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M353.49,338.92v3.4c0,2.2-1.2,4.2-3,5.2l155.6-89.8c2-1,3-3,3-5.2v-37.6l-6,3.4v34.2L353.49,338.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M502.89,211.32c2-1.2,4-2.4,6-3.4v-7l-6,3.4V211.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M509.09,215.12v-7c-2,1.2-4,2.4-6,3.4v7L509.09,215.12z"
}), React.createElement("polygon", {
  className: "st1",
  points: "496.89,174.52 496.89,208.12 502.89,204.52 502.89,170.72 353.49,257.12 353.49,257.12  "
}), React.createElement("path", {
  className: "st1",
  d: "M362.29,285.72l3-1.8c0-7.4,0-14.8,0-23c31.6-18.4,63.4-36.6,95.2-55v-3.6c0-2.2,1.2-4.2,3-5.2l18.8-11 l-120,69.4c-2,1-3,3-3,5.2v26.6L362.29,285.72L362.29,285.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M368.09,320.12c-1,0.6-2,0.8-3,0.8C366.09,320.72,367.29,320.72,368.09,320.12l119.8-69.2l0,0L368.09,320.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M490.69,247.72c-0.2,0.2,0,0.6-0.2,0.8C490.49,248.32,490.49,248.12,490.69,247.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M488.09,250.72L488.09,250.72L488.09,250.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M491.09,245.72l0.2-0.2L491.09,245.72z"
}), React.createElement("polygon", {
  className: "st1",
  points: "353.49,331.92 353.49,338.92 502.89,252.72 502.89,218.32 496.89,221.92 496.89,249.32  "
}), React.createElement("path", {
  className: "st1",
  d: "M496.89,215.12c2-1.2,4-2.4,6-3.6v-7l-6,3.6V215.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M362.29,285.72l-3,1.8v3.4C359.29,288.92,360.09,286.92,362.29,285.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M496.89,221.92l6-3.6v-7c-2,1.2-4,2.4-6,3.6V221.92z"
}), React.createElement("polygon", {
  className: "st1",
  points: "493.09,158.32 499.29,154.72 479.69,143.32 473.69,146.92 481.69,151.52  "
}), React.createElement("path", {
  className: "st1",
  d: "M316.29,228.92l1.6,0.8l145-83.8l10.6-6.2l-1.6-0.8c-2-1-4.2-1-6,0l-155.6,89.8 C312.29,227.72,314.49,227.72,316.29,228.92z"
}), React.createElement("polygon", {
  className: "st1",
  points: "317.89,229.92 319.29,230.72 469.09,144.32 473.69,146.92 479.69,143.32 473.69,139.92 462.89,145.92  "
}), React.createElement("polygon", {
  className: "st1",
  points: "494.29,159.52 497.89,153.32 497.89,153.32  "
}), React.createElement("path", {
  className: "st1",
  d: "M496.89,160.32l3-1.8c1.6-1,3.4-0.8,5-0.2l0.2-0.2l-6-3.4l-6,3.4L496.89,160.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M506.09,158.72l-0.8-0.4l-0.2,0.2C505.49,158.32,505.69,158.32,506.09,158.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M506.09,169.32c2-1,3-3,3-5.2c0-0.2-0.2-0.4-0.2-0.8l-5.8,3.4v4.4L506.09,169.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M504.89,158.32c-1.6-0.6-3.6-0.6-5,0.2l-3,1.8l2.4,1.4L504.89,158.32z"
}), React.createElement("polygon", {
  className: "st1",
  points: "502.89,166.52 508.69,163.32 508.69,163.32  "
}), React.createElement("path", {
  className: "st1",
  d: "M499.29,161.92l3.8,2.2v2.6l5.8-3.4c-0.2-1.8-1.2-3.6-2.8-4.6c-0.2-0.2-0.6-0.2-1-0.2L499.29,161.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M353.49,253.92v3.4l149.6-86.4v-4.4l-149.8,86.4C353.49,253.32,353.49,253.32,353.49,253.92z"
}), React.createElement("polygon", {
  className: "st1",
  points: "353.09,253.12 502.89,166.52 502.89,166.52  "
}), React.createElement("path", {
  className: "st1",
  d: "M353.09,253.12l149.8-86.4v-2.6l-150.4,86.8C352.89,251.32,353.09,252.12,353.09,253.12z"
}), React.createElement("polygon", {
  className: "st1",
  points: "343.69,244.52 343.69,244.52 325.49,233.92 469.09,151.32 487.29,161.92 493.09,158.32 481.69,151.52  473.69,146.92 324.09,233.32  "
}), React.createElement("polygon", {
  className: "st1",
  points: "473.69,146.92 469.09,144.32 319.29,230.72 324.09,233.32  "
}), React.createElement("polygon", {
  className: "st1",
  points: "488.49,163.12 491.89,156.92 491.89,156.92  "
}), React.createElement("path", {
  className: "st1",
  d: "M343.69,244.52L343.69,244.52L343.69,244.52z"
}), React.createElement("polygon", {
  className: "st1",
  points: "490.69,163.92 400.69,215.72 496.89,160.32 493.09,158.32 487.29,161.92  "
}), React.createElement("rect", {
  x: 345.49,
  y: 243.32,
  className: "st1",
  width: 0,
  height: 4.4
}), React.createElement("polygon", {
  className: "st1",
  points: "347.49,246.92 347.49,246.92 347.49,246.92 349.89,248.12 494.89,164.52 499.29,161.92 496.89,160.32  400.69,215.72  "
}), React.createElement("path", {
  className: "st1",
  d: "M349.89,248.12l0.8,0.4c1,0.6,1.8,1.4,2.2,2.2l150.4-86.8l-3.8-2.2l-4.6,2.6L349.89,248.12z"
}), React.createElement("path", {
  className: "st0",
  d: "M304.29,461.92c-4.6,2.6-8.6,9.8-8.6,15c0,1.6,0.4,2.2,0.4,2.4c0,0,0.8-0.2,2.2-0.8c4.6-2.6,8.6-9.6,8.6-15 c0-1.4-0.4-2.2-0.4-2.4C306.69,461.32,305.69,461.32,304.29,461.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M312.89,450.72c-4-2.4-9.2-2.2-14.4,0.8l0,0c-8.2,4.8-14.8,16-14.8,25.4c0,5.8,2.4,10.4,6.4,12.8 c1.8,1,4,1.6,6,1.6c2.6,0,5.6-0.8,8.2-2.4c8.2-4.8,14.6-16,14.6-25.4C319.29,457.72,316.69,453.12,312.89,450.72z M301.29,483.72 c-6.4,3.8-11.6,0.8-11.6-6.8c0-7.4,5.2-16.4,11.6-20.2s11.6-0.6,11.6,6.8S307.89,480.12,301.29,483.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M301.29,456.92c-6.4,3.8-11.6,12.8-11.6,20.2s5.2,10.4,11.6,6.8c6.4-3.8,11.6-12.8,11.6-20.2 C312.89,455.92,307.89,453.12,301.29,456.92z M298.49,478.32c-1.2,0.8-2.2,0.8-2.2,0.8c-0.2-0.2-0.4-0.8-0.4-2.4 c0-5.2,4.2-12.2,8.6-15c1.2-0.8,2.2-0.8,2.2-0.8c0.2,0.2,0.4,0.8,0.4,2.4C306.89,468.92,302.89,475.72,298.49,478.32z"
}), React.createElement("path", {
  className: "st0",
  d: "M304.29,534.32c-4.6,2.6-8.6,9.8-8.6,15c0,1.4,0.4,2.2,0.4,2.4c0,0,0.8-0.2,2.2-0.8c4.6-2.6,8.6-9.8,8.6-15 c0-1.6-0.4-2.2-0.4-2.4C306.69,533.72,305.69,533.72,304.29,534.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M312.89,522.92c-4.2-2.4-9.2-2.2-14.4,0.8c-8.2,4.8-14.8,16-14.8,25.4c0,5.8,2.4,10.4,6.4,12.8 c1.8,1,4,1.6,6,1.6c2.6,0,5.6-0.8,8.2-2.4c8.2-4.8,14.6-15.8,14.6-25.4C319.29,530.32,316.69,525.52,312.89,522.92z M301.29,555.92 c-6.4,3.8-11.6,0.8-11.6-6.6s5.2-16.6,11.6-20.2c6.4-3.8,11.6-0.6,11.6,6.8C312.89,543.12,307.89,552.52,301.29,555.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M301.29,529.12c-6.4,3.8-11.6,12.8-11.6,20.2s5.2,10.4,11.6,6.6c6.4-3.6,11.6-12.8,11.6-20.2 C312.89,528.32,307.89,525.52,301.29,529.12z M298.49,550.72c-1.2,0.8-2.2,0.8-2.2,0.8c-0.2-0.2-0.4-0.8-0.4-2.4 c0-5.2,4.2-12.4,8.6-15c1.2-0.8,2.2-0.8,2.2-0.8c0.2,0.2,0.4,0.8,0.4,2.4C306.89,540.92,302.89,548.12,298.49,550.72z"
}), React.createElement("path", {
  className: "st0",
  d: "M304.29,611.32c-4.6,2.6-8.6,9.8-8.6,15c0,1.4,0.4,2.2,0.4,2.4c0,0,0.8-0.2,2.2-0.8c4.6-2.6,8.6-9.6,8.6-15 c0-1.4-0.4-2.2-0.4-2.4C306.69,610.52,305.69,610.52,304.29,611.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M312.89,600.12c-4.2-2.4-9.2-2.2-14.4,0.8l0,0c-8.2,4.8-14.8,15.8-14.8,25.4c0,5.8,2.4,10.4,6.4,12.8 c1.8,1,4,1.6,6,1.6c2.6,0,5.6-0.8,8.2-2.4c8.4-4.8,14.6-15.8,14.6-25.4C319.29,606.92,316.69,602.52,312.89,600.12z M301.29,632.92 c-6.4,3.8-11.6,0.8-11.6-6.6s5.2-16.6,11.6-20.2c6.4-3.8,11.6-0.6,11.6,6.6C312.89,620.32,307.89,629.12,301.29,632.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M301.29,605.92c-6.4,3.6-11.6,12.8-11.6,20.2s5.2,10.4,11.6,6.6s11.6-12.8,11.6-20.2 C312.89,605.52,307.89,602.12,301.29,605.92z M298.49,627.72c-1.2,0.8-2.2,0.8-2.2,0.8c-0.2-0.2-0.4-0.8-0.4-2.4 c0-5.2,4.2-12.4,8.6-15c1.2-0.8,2.2-0.8,2.2-0.8c0.2,0.2,0.4,0.8,0.4,2.4C306.89,617.92,302.89,625.12,298.49,627.72z"
}), React.createElement("path", {
  className: "st2",
  d: "M194.89,916.52v-4.2c0-1,0-2.2,0-3.2v-3.2v-532.4c0-1.6,0-3.4,0-5v-3.2c0-3.6,0.6-7.4,1.4-11 c0-0.4,0-0.6,0.2-1c0-0.2,0.2-0.4,0.2-0.6c0.2-1,0.4-2,0.8-3.2c0.2-0.4,0.4-1,0.6-1.4c0.4-1.2,0.8-2.2,1.2-3.4c0.4-1,0.8-2,1.2-3 c0.2-0.4,0.2-0.8,0.4-1l-21.2-12.2c-0.8,1.6-1.4,3.4-2,5c-0.2,0.4-0.2,0.6-0.4,1c-1.8,5.6-2,11-2.2,16.6v6.2v4.4v530v4.6 c0,1.2,0,2.4,0.2,3.4c0,0.2,0,0.4,0,0.6c0,1.2,0.2,2.2,0.4,3.2c0,0.2,0.2,0.4,0.2,0.6c0.2,0.8,0.4,1.8,0.8,2.4 c0.2,0.6,0.6,1,0.8,1.4c0.2,0.2,0.4,0.6,0.6,0.8c0.6,0.8,1.4,1.4,2.4,2l14.4,8.4c0-0.6,0-1.4,0-2 C195.09,916.72,194.89,916.72,194.89,916.52z"
}), React.createElement("path", {
  className: "st2",
  d: "M180.69,910.52c-1-0.6-1.6-1.2-2.4-2C179.29,909.32,179.89,910.12,180.69,910.52z"
}), React.createElement("path", {
  className: "st2",
  d: "M179.89,328.32c-0.8,1.6-1.4,3.4-1.8,5C178.49,331.92,179.29,330.12,179.89,328.32L179.89,328.32z"
}), React.createElement("path", {
  className: "st2",
  d: "M176.09,904.12c0-0.2-0.2-0.4-0.2-0.6C176.09,903.72,176.09,903.92,176.09,904.12z"
}), React.createElement("path", {
  className: "st2",
  d: "M175.49,895.92v-4.6C175.49,892.92,175.49,894.32,175.49,895.92z"
}), React.createElement("path", {
  className: "st2",
  d: "M175.49,356.92v-6.2C175.49,353.12,175.49,355.12,175.49,356.92z"
}), React.createElement("path", {
  className: "st2",
  d: "M197.89,349.52c0.2-0.4,0.4-0.8,0.4-1.4l0,0C197.89,348.32,197.89,348.92,197.89,349.52z"
}), React.createElement("path", {
  className: "st2",
  d: "M195.09,919.12c0-0.6,0-1.2,0-1.8v-0.2C195.09,917.72,195.09,918.12,195.09,919.12z"
}), React.createElement("path", {
  className: "st2",
  d: "M177.29,906.72c0.2,0.4,0.6,0.8,0.8,1.2C177.49,907.72,177.49,907.12,177.29,906.72 C176.89,906.72,176.89,906.72,177.29,906.72z"
}), React.createElement("path", {
  className: "st2",
  d: "M175.49,900.12c0-0.2,0-0.4,0-0.6C175.49,899.52,175.49,899.92,175.49,900.12z"
}), React.createElement("polygon", {
  className: "st2",
  points: "194.89,368.32 194.89,368.32 194.89,365.12  "
}), React.createElement("path", {
  className: "st2",
  d: "M194.89,916.52c0,0.2,0,0.4,0,0.6C194.89,916.72,194.89,916.72,194.89,916.52v-1c0-1,0-2,0-3.2V916.52z"
}), React.createElement("path", {
  className: "st2",
  d: "M194.89,365.12c0-0.6,0.2-1,0.2-1.6c0.2-1.8,0.4-3.8,0.6-5.8c0.2-1,0.4-2,0.6-3c0-0.2,0-0.6,0.2-0.8 C195.49,357.72,194.89,361.52,194.89,365.12z"
}), React.createElement("path", {
  className: "st2",
  d: "M196.69,352.72c0.2-0.4,0.2-0.8,0.4-1.4s0.2-1.2,0.4-1.8C197.49,350.32,197.29,351.32,196.69,352.72z"
}), React.createElement("path", {
  className: "st2",
  d: "M199.29,344.52c0.2-0.6,0.6-1.2,0.8-1.8c0-0.2,0.2-0.4,0.2-0.6s0.2-0.4,0.2-0.6 C200.09,342.72,199.89,343.72,199.29,344.52z"
}), React.createElement("path", {
  className: "st2",
  d: "M196.29,355.12c-0.2,1-0.4,2-0.6,3C196.09,356.92,196.09,355.92,196.29,355.12z"
}), React.createElement("path", {
  className: "st2",
  d: "M200.49,342.12c0,0.2-0.2,0.4-0.2,0.6C200.49,342.72,200.49,342.52,200.49,342.12z"
}), React.createElement("path", {
  className: "st2",
  d: "M195.09,916.72c0,0.2,0,0.2,0,0.4v0.2c0-0.6,0-1.2,0-1.8V916.72z"
}), React.createElement("path", {
  className: "st2",
  d: "M194.89,368.32c0-1.6,0-3,0.2-4.6c0,0.6-0.2,1-0.2,1.6V368.32z"
}), React.createElement("path", {
  className: "st2",
  d: "M197.29,351.32c0.2-1,0.6-2.2,1-3.2c-0.2,0.4-0.4,0.8-0.4,1.4C197.49,350.12,197.49,350.72,197.29,351.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M163.69,344.52v-0.2V344.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M170.49,917.72c-0.6-0.6-1-1-1.4-1.6C169.29,916.72,169.89,916.92,170.49,917.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M166.29,330.12c1.2-3.8,3-7.6,5-11.4C169.29,322.12,167.49,325.92,166.29,330.12z"
}), React.createElement("polygon", {
  className: "st1",
  points: "172.29,316.92 172.29,316.92 172.49,316.92  "
}), React.createElement("path", {
  className: "st1",
  d: "M163.09,891.32c0,1.8,0,3.6,0,5.6V891.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M164.49,907.72c0-0.2,0-0.2-0.2-0.4C164.49,907.52,164.49,907.52,164.49,907.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M166.29,912.52c0,0.2,0.2,0.2,0.4,0.4c-0.2-0.4-0.4-1-0.8-1.4C166.09,911.72,166.09,911.92,166.29,912.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M207.29,330.12l-21.4-12.2c-1.2,1.6-2.2,3.2-3.4,5l21.2,12.2C204.89,333.72,206.09,331.92,207.29,330.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M164.29,907.12c0,0.2,0,0.2,0.2,0.4c0.4,1.2,0.8,2.6,1.4,3.8c0.2,0.4,0.4,1,0.8,1.4c0.6,1.2,1.4,2.2,2.2,3.2 c0.4,0.6,1,1,1.4,1.6c1.2,1.2,2.4,2.2,3.8,3.2l31.8,18.4c-4.4-2.6-7.6-7-9.2-12.4l-19.4-11.2c-0.4-0.2-0.6-0.6-0.8-0.8 c-1-0.8-2-1.6-2.8-2.6c-0.2-0.4-0.4-0.6-0.8-1c-0.4-0.6-1-1.2-1.2-1.8c-0.2-0.2-0.2-0.6-0.2-0.8c-0.4-1-0.8-1.8-1-2.8 c-0.2-0.6-0.4-1-0.4-1.6c-0.2-1.2-0.4-2.6-0.4-3.8c0-0.6-0.2-1-0.2-1.6c0-0.2,0-0.4,0-0.6v-2c0-2.6,0-5.2,0-7.6v-527 c0-3.6,0-7,0-10.4v-4.2c0.2-5.2,1-9.8,2.4-14v-0.2c1.4-4.4,3.2-8.8,5.6-12.8l0,0c1.2-1.8,2.2-3.4,3.4-5l-0.4-0.2 c-2.8-1.6-6.4-0.8-8.2,2c0,0,0,0.2-0.2,0.2c-0.4,0.6-0.6,1.2-0.8,1.6c-2,3.8-3.6,7.4-5,11.4c-0.2,0.4-0.2,0.6-0.4,1 c-1.4,4.6-2,9-2.4,13.2v0.2c-0.4,4.2-0.2,8.6-0.2,12.8v431.8v102.2v5.6C163.49,900.32,163.69,903.92,164.29,907.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M186.09,318.12l-5.2-3c-1.2,1.6-2.2,3.2-3.4,5l5.2,3C183.69,321.32,184.89,319.52,186.09,318.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M177.49,915.52c-0.4-0.2-0.6-0.4-0.8-0.8C176.69,915.12,176.89,915.52,177.49,915.52l19.4,11.2l0,0 L177.49,915.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M169.29,346.92v4.2c0-6,0.4-11.8,2.4-18.2C170.49,337.12,169.69,341.52,169.29,346.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M169.89,904.12c-0.2-1.2-0.4-2.6-0.4-3.8C169.69,901.72,169.89,902.92,169.89,904.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M171.29,908.72c-0.4-1-0.8-1.8-1-2.8C170.69,906.72,171.09,907.92,171.29,908.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M169.29,897.92c0,0.2,0,0.4,0,0.6c0-0.8,0-1.8,0-2.6V897.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M173.69,912.12c-0.2-0.4-0.4-0.6-0.8-1C173.09,911.72,173.49,911.92,173.69,912.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M207.29,915.92v0.4c0,1.8,0.2,3.2,0.4,4.6c0,0.2,0.2,0.6,0.2,0.8C207.49,920.12,207.29,918.12,207.29,915.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M207.29,365.32v7.8c0-6,0-11.2,1.2-16.8C207.89,359.32,207.49,362.12,207.29,365.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M211.29,347.52c0.8-2,1.8-4,3-5.8c0,0,0,0,0,0.2C213.09,343.72,212.29,345.32,211.29,347.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M207.89,922.52c0.4,1.2,0.8,2.2,1.2,3.2C208.69,924.52,208.09,923.72,207.89,922.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M212.29,928.92C212.29,928.92,212.49,928.92,212.29,928.92c-1-0.8-2-1.6-2.6-2.6 C210.49,926.92,211.09,927.92,212.29,928.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M210.09,350.12C210.09,350.32,210.09,350.32,210.09,350.12c-0.4,1-0.8,1.8-1,2.8c-0.2,0.6-0.4,1.4-0.6,2 C209.29,353.32,209.89,351.92,210.09,350.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M208.49,356.32c-0.8,3-1.2,6.2-1.2,9v0.2C207.49,361.92,207.89,359.32,208.49,356.32L208.49,356.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M209.29,353.12c-0.2,0.8-0.4,1.8-0.6,2.6c0-0.2,0.2-0.4,0.2-0.4C209.09,354.52,209.09,353.72,209.29,353.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M209.69,926.32L209.69,926.32c0.6,1,1.4,2,2.4,2.6h0.2C211.09,927.92,210.49,926.92,209.69,926.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M210.09,350.12v0.2V350.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M207.49,920.72c-0.2-1.2-0.4-2.8-0.4-4.6C207.29,917.92,207.49,919.52,207.49,920.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M214.29,341.52L214.29,341.52C214.29,341.32,214.29,341.32,214.29,341.52c0.2-0.2,0.2-0.2,0.2-0.2 c-1.2,2-2.2,4.2-3.2,6.2c0-0.2,0.2-0.2,0.2-0.4C212.29,345.32,213.09,343.72,214.29,341.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M207.29,330.12c-1.2,1.6-2.4,3.4-3.4,5l0,0C204.89,333.72,206.09,331.92,207.29,330.12L207.29,330.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M202.89,926.52c0,0.2,0.2,0.4,0.2,0.6c-0.4-0.8-0.6-1.8-1-2.8C202.49,924.72,202.49,925.52,202.89,926.52 C202.89,926.32,202.89,926.32,202.89,926.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M205.09,930.32c-0.2-0.2-0.4-0.6-0.6-0.8c0.2,0.2,0.2,0.4,0.4,0.6C204.89,930.12,204.89,930.12,205.09,930.32z "
}), React.createElement("path", {
  className: "st1",
  d: "M201.69,920.52c0,0.2,0,0.2,0,0.4c-0.2-1.2-0.4-2.6-0.4-4l0,0C201.09,918.12,201.29,919.32,201.69,920.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M209.29,338.32L209.29,338.32c0.6-1,1.2-1.8,2-3C210.49,336.32,209.89,337.12,209.29,338.32L209.29,338.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M214.29,937.12c0.4-0.6,0.4-1,0.6-1.6c-2.2-0.2-4.2-0.6-5.8-1.6l0,0l-12.2-7c1.8,5.4,4.8,9.8,9.2,12.4 c1,0.6,2,0.8,3,0.8C211.09,940.12,212.89,939.12,214.29,937.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M204.49,348.32c0.4-1,0.8-2.2,1.2-3.2C205.09,346.32,204.89,347.52,204.49,348.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M201.09,376.32v-6.8C201.09,371.52,201.09,373.92,201.09,376.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M209.09,934.12C209.09,934.12,209.09,933.92,209.09,934.12c-0.2-0.2-0.4-0.4-0.6-0.6 C208.69,933.72,208.69,933.92,209.09,934.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M203.09,926.92C203.09,926.92,203.09,926.72,203.09,926.92c-0.2-0.4-0.2-0.6-0.4-0.8 C202.89,926.72,202.89,926.72,203.09,926.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M204.89,930.12c-0.2-0.2-0.2-0.4-0.4-0.6c-0.4-0.6-0.8-1-1-1.6C204.09,928.72,204.29,929.12,204.89,930.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M212.29,333.12l-5-2.8c-1.2,1.6-2.2,3.2-3.4,5l5.2,3c0.6-1,1.2-2,2-3c0.4-0.8,0.8-1.4,1.4-2.2 C212.49,333.32,212.49,333.32,212.29,333.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M201.89,923.12c0.2,1,0.6,2,0.8,3c-0.2-0.6-0.4-1.4-0.6-2.2c-0.2-0.4-0.2-0.8-0.4-1.2 C201.89,922.92,201.89,923.12,201.89,923.12z"
}), React.createElement("polygon", {
  className: "st1",
  points: "196.69,926.72 196.69,926.72 209.09,934.12  "
}), React.createElement("path", {
  className: "st1",
  d: "M201.69,920.52c-0.2-1.2-0.2-2.2-0.4-3.6C201.09,918.12,201.29,919.32,201.69,920.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M202.49,354.52c0,0.2,0,0.6-0.2,0.8c0.2-0.4,0.2-1,0.4-1.4C202.89,354.32,202.49,354.52,202.49,354.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M201.09,915.72v-10C201.09,909.12,201.09,912.52,201.09,915.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M207.89,922.52C207.89,922.52,207.89,922.12,207.89,922.52c0.2,1.2,0.8,2.2,1.2,3.2l0,0 C208.69,924.52,208.49,923.72,207.89,922.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M209.29,353.12c0.2-0.8,0.6-1.8,1-2.6C209.89,351.32,209.69,352.12,209.29,353.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M212.49,929.12L212.49,929.12c-0.2-0.2-0.2-0.2-0.2-0.2l0,0C212.49,928.92,212.49,929.12,212.49,929.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M212.49,929.12c0.6,0.4,1.2,1,1.6,1.6C213.69,930.12,213.09,929.52,212.49,929.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M207.49,920.72c0,0.4,0.2,0.6,0.2,1c0,0,0,0,0-0.2C207.89,921.52,207.49,921.32,207.49,920.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M214.49,931.72c0.2,0.4,0.4,0.6,0.4,1C214.89,932.52,214.89,931.92,214.49,931.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M214.89,932.92c0-0.4-0.2-0.6-0.4-1c-0.2-0.4-0.2-0.8-0.4-1c-0.4-0.6-1-1.2-1.6-1.6l0,0 c-0.2,0-0.2-0.2-0.4-0.2h-0.2c-1-0.6-1.8-1.4-2.6-2.6c-0.2-0.2-0.2-0.4-0.4-0.6c-0.6-1-1-2-1.4-3.4v-0.2v-0.2c0-0.4-0.2-0.6-0.2-1 c-0.2-1.4-0.4-2.8-0.4-4.6v-0.4c0-2.2,0-4.6,0-6.8v-434.4v-101.4v-7.8v-0.2c0-2.8,0.6-6,1.2-9v-0.2c0-0.2,0-0.2,0.2-0.4 c0.2-0.8,0.4-1.8,0.6-2.6s0.6-1.8,1-2.6v-0.2c0.4-0.8,0.6-1.8,1-2.6c1-2.2,2-4.2,3.2-6.2c0.8-1.4,1-3,0.6-4.6 c-0.4-1.4-1.4-2.6-2.6-3.6c-0.4,0.6-1,1.4-1.4,2c-0.6,1-1.4,2-2,3c-1.2,2-2.2,4.2-3.2,6.4c-0.6,1.2-1,2.4-1.4,3.6 c-0.6,1.6-1.2,3.4-1.6,5.2c-0.2,0.8-0.4,1.6-0.6,2.4c-0.2,1.2-0.4,2.4-0.6,3.6c-0.2,0.8-0.2,1.6-0.2,2.4c-0.2,2.4-0.4,4.8-0.4,7.4 v6.8v529.6v10c0,0.4,0,0.8,0,1c0,1.4,0.2,2.6,0.4,4c0,0.4,0.2,1,0.2,1.4c0.2,0.6,0.2,1.2,0.4,1.8c0.2,1,0.6,2,1,2.8 c0.4,0.8,1,1.8,1.4,2.6c0.2,0.2,0.4,0.6,0.6,0.8c0.2,0.2,0.2,0.4,0.4,0.6c1,1.2,2,2.2,3.4,3.2c1.8,1,3.8,1.4,5.8,1.6 C215.09,934.52,215.09,933.72,214.89,932.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M202.29,924.12c-0.2-0.6-0.4-1.2-0.4-1.8c0,0.2,0,0.4,0,0.6C201.89,923.12,202.29,923.72,202.29,924.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M204.49,348.32L204.49,348.32c0.4-1.2,0.8-2.2,1.4-3.4c0,0.2-0.2,0.2-0.2,0.4 C205.09,346.32,204.89,347.52,204.49,348.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M208.49,933.32c0.2,0.2,0.4,0.4,0.6,0.6c-1.4-1-2.6-2-3.4-3.2C206.29,931.72,207.29,932.72,208.49,933.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M211.09,335.32c0.4-0.6,1-1.4,1.4-2l0,0C211.89,333.92,211.69,334.52,211.09,335.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M201.69,359.52c-0.2,0.8-0.2,1.6-0.2,2.4C201.69,361.32,201.69,360.12,201.69,359.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M203.69,927.92c0.2,0.6,0.6,1,1,1.6c-0.6-0.8-1-1.6-1.4-2.6v0.2C203.49,927.12,203.49,927.72,203.69,927.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M202.49,355.32c0,0.2,0,0.4,0,0.6c0.2-0.8,0.4-1.6,0.6-2.4c0,0.2,0,0.2-0.2,0.4 C202.49,354.52,202.49,355.12,202.49,355.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M175.49,897.92c0,0.6,0,0.8,0.2,1.4c0-1.2-0.2-2.4-0.2-3.4V897.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M200.49,341.52c1-2.2,2-4.4,3.2-6.4l-21.2-12.2l-0.2,0.2c-1,1.8-1.8,3.4-2.6,5.2l21.2,12.2 C201.09,340.92,200.69,341.32,200.49,341.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M177.89,333.32c-1.4,4-2.2,8.4-2.6,13.6v3.8c0-5.6,0.4-11,2.2-16.6C177.49,333.92,177.89,333.92,177.89,333.32 z"
}), React.createElement("path", {
  className: "st1",
  d: "M176.09,903.32c-0.2-1-0.4-2.2-0.4-3.2C175.49,901.32,175.69,902.52,176.09,903.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M194.89,373.32v-5C194.89,370.12,194.89,371.52,194.89,373.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M196.69,353.32c0,0.4-0.2,0.6-0.2,1c0.2-0.6,0.2-1,0.4-1.6C196.69,352.72,196.69,353.12,196.69,353.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M198.09,348.12c0-0.2,0-0.2,0.2-0.4c0.4-1,0.8-2,1.2-3C199.09,345.72,198.69,346.92,198.09,348.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M194.89,909.12c0,1,0,2.2,0,3.2v-6.4V909.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M178.49,908.72c-0.2-0.2-0.4-0.6-0.6-0.8C178.09,907.92,178.09,908.32,178.49,908.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M176.89,906.52c-0.4-0.8-0.6-1.6-0.8-2.4C176.29,904.72,176.69,905.72,176.89,906.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M176.29,914.72c-1-0.8-2-1.6-2.8-2.6C174.29,913.12,175.49,914.12,176.29,914.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M171.69,909.52c0.4,0.6,0.8,1.2,1.2,1.8c-0.6-0.8-1.2-1.8-1.6-2.6C171.69,909.12,171.69,909.12,171.69,909.52z "
}), React.createElement("path", {
  className: "st1",
  d: "M177.49,320.12L177.49,320.12c-2.4,4-4.4,8.2-5.8,12.6v0.2C172.89,328.72,174.89,324.52,177.49,320.12 L177.49,320.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M169.29,361.52v-10.4C169.29,354.52,169.29,357.72,169.29,361.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M170.49,905.72c-0.2-0.6-0.4-1-0.4-1.6C170.09,904.52,170.49,905.32,170.49,905.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M169.29,895.92v-7.6C169.29,890.72,169.29,893.32,169.29,895.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M169.69,900.32c0-0.6-0.2-1-0.2-1.6C169.29,899.12,169.69,899.92,169.69,900.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M198.09,348.12c0-0.2,0-0.2,0.2-0.4C198.49,347.72,198.09,348.12,198.09,348.12L198.09,348.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M196.69,926.72c-1-3-1.6-6-1.6-9.6c0,0.6,0,1.2,0,1.8l-14.4-8.4c-1-0.6-1.6-1.4-2.4-2 c-0.2-0.2-0.4-0.6-0.6-0.8c-0.2-0.4-0.6-0.8-0.8-1.2v-0.2c-0.4-0.6-0.6-1.6-0.8-2.4c0-0.2-0.2-0.4-0.2-0.6c-0.2-1-0.4-2-0.4-3.2 c0-0.2,0-0.4,0-0.6c0-0.4-0.2-0.8-0.2-1.4v-2.2c0-1.6,0-3,0-4.6v-529.8v-4.4c0-2.2,0-4.2,0-6.2v-3.8c0.2-5.4,1.2-9.6,2.6-13.6 c0.6-1.8,1.2-3.4,1.8-5h0.2c0.8-1.6,1.6-3.4,2.6-5.2l0.2-0.2l-5.2-3c0,0,0,0,0,0.2c-2.4,4.6-4.4,8.6-5.6,12.8 c-1.8,6.4-2.2,12.2-2.4,18.2v10.4v527v7.6c0,0.8,0,1.8,0,2.6c0,0.6,0.2,1,0.2,1.6c0.2,1.4,0.2,2.6,0.4,3.8c0.2,0.6,0.2,1.2,0.4,1.6 c0.2,1,0.6,2,1,2.8c0.4,1,1,1.8,1.6,2.6c0.2,0.4,0.4,0.6,0.8,1c0.8,0.8,1.8,1.8,2.8,2.6c0.4,0.2,0.6,0.6,0.8,0.8L196.69,926.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M195.69,358.12c-0.2,2-0.4,3.8-0.6,5.8C195.49,361.52,195.49,359.92,195.69,358.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M194.89,373.32v532.4v6.4c0,1,0,2,0,3.2v-547l0,0V373.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M196.69,354.32c0,0.2,0,0.6-0.2,0.8c0.2-1.2,0.6-2.6,1-3.8c-0.2,0.4-0.2,0.8-0.4,1.4 C196.69,353.12,196.69,353.72,196.69,354.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M200.49,341.52c0,0.2-0.2,0.4-0.2,0.6c1-2.2,2.2-4.4,3.4-6.6c0-0.2,0.2-0.2,0.2-0.2l0,0 C202.89,337.52,201.69,339.52,200.49,341.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M198.49,347.72c0.6-1.6,1.2-3.4,2-5c-0.2,0.6-0.6,1.2-0.8,1.8C199.09,345.72,198.69,346.52,198.49,347.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M205.49,930.52c0-0.2-0.2-0.2-0.2-0.4l-0.2-0.2C204.89,930.32,205.09,930.52,205.49,930.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M209.29,338.32L209.29,338.32c-0.8,1.2-1.2,2.2-1.6,3.4C207.89,340.72,208.69,339.52,209.29,338.32 L209.29,338.32L209.29,338.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M201.69,921.72c0-0.2,0-0.6,0-1c0-0.2,0-0.2,0-0.4C201.69,920.92,201.69,921.52,201.69,921.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M201.09,916.92L201.09,916.92c0-0.2,0-0.4,0-0.6C201.09,916.72,201.09,916.72,201.09,916.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M202.89,926.52C202.89,926.32,202.89,926.32,202.89,926.52C202.89,926.32,202.89,926.32,202.89,926.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M203.49,351.32c0.2-1,0.6-1.8,1-2.8C204.09,349.52,203.69,350.72,203.49,351.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M205.49,930.52c-0.2-0.2-0.2-0.4-0.4-0.6c-0.6-0.6-1-1.4-1.4-2.2c-0.2-0.2-0.2-0.6-0.4-0.8s-0.2-0.4-0.4-0.8 c0,0,0,0,0-0.2c-0.4-1-0.6-1.8-0.8-3c0-0.2,0-0.2,0-0.4c0-0.4-0.2-0.6-0.2-1c0-0.4,0-0.8-0.2-1.2c-0.2-1.2-0.2-2.4-0.4-3.6 c0-0.2,0-0.4,0-0.6v-0.6c-0.2-3.4,0-7,0-10v-529.2c0-2.4,0-4.6,0-6.8v-4.2c0-3.2,0.6-6.4,1.2-9.8c0-0.2,0-0.6,0.2-0.8 c0-0.2,0.2-0.4,0.2-0.6c0.2-0.8,0.4-1.6,0.6-2.4c0.2-1,0.6-1.8,1-2.8c0-0.2,0-0.2,0.2-0.4c0.4-1,0.8-2.2,1.2-3.2 c0.6-1.2,1.2-2.4,1.8-3.6c0.6-1,1-2,1.6-3.2c0,0,0,0,0.2-0.2l-5.2-3c0,0.2-0.2,0.2-0.2,0.2c-1.2,2.2-2.4,4.4-3.4,6.6 c0,0.2-0.2,0.4-0.2,0.6c-0.8,1.6-1.4,3.2-2,5c0,0.2,0,0.2-0.2,0.4c-0.4,1-0.6,2-1,3.2s-0.6,2.4-1,3.8c-0.2,1-0.4,2-0.6,3 c-0.2,1.8-0.4,3.8-0.6,5.8c0,1.6-0.2,3.2-0.2,4.6v547c0,0.6,0,1.2,0,1.8c0,3.6,0.6,6.8,1.6,9.6l12.2,7.2c-0.2-0.2-0.4-0.4-0.6-0.6 C207.29,932.72,206.09,931.72,205.49,930.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M202.49,355.92c-0.2,1.2-0.4,2.4-0.6,3.6C201.89,358.32,202.29,357.12,202.49,355.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M201.09,916.92c0-0.4,0-0.8,0-1v0.6C201.09,916.72,201.09,916.72,201.09,916.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M201.09,369.52c0-2.4,0.2-5,0.4-7.4c-0.2,1-0.2,2-0.4,3.2V369.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M205.49,930.52c-0.2-0.2-0.2-0.4-0.4-0.6C205.09,930.32,205.49,930.32,205.49,930.52L205.49,930.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M201.69,922.12c0-0.4-0.2-1-0.2-1.4c0,0.4,0,0.6,0,1C201.69,921.92,201.69,922.12,201.69,922.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M205.69,345.12c1-2.2,2-4.4,3.2-6.4c-0.6,1-1,2.2-1.6,3.2C206.89,342.72,206.29,343.92,205.69,345.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M203.49,351.32c-0.2,0.6-0.4,1.4-0.4,2c0.4-1.8,1-3.4,1.6-5.2c0,0.2,0,0.2-0.2,0.4 C204.09,349.52,203.69,350.72,203.49,351.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M202.89,353.92c0-0.2,0-0.2,0.2-0.4c0.2-0.6,0.2-1.4,0.4-2C203.09,352.52,202.89,353.32,202.89,353.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M201.69,922.92c0-0.2,0-0.4,0-0.6s0-0.2-0.2-0.4C201.69,922.12,201.69,922.72,201.69,922.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M203.69,927.92c-0.2-0.2-0.2-0.6-0.4-0.8C203.49,927.12,203.49,927.72,203.69,927.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M201.09,365.12c0-1.2,0.2-2.2,0.4-3.2c0-0.8,0.2-1.6,0.2-2.4c0.2-1.2,0.4-2.4,0.6-3.6c0-0.2,0-0.4,0-0.6 C201.69,358.92,201.09,361.92,201.09,365.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M205.69,345.12c0-0.2,0.2-0.2,0.2-0.4c0.4-1,1-2.2,1.6-3.2C206.69,342.72,206.09,343.92,205.69,345.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M204.29,348.92c0-0.2,0-0.2,0.2-0.4l0,0C204.49,348.72,204.29,348.72,204.29,348.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M208.49,933.32c-1.2-0.8-2-1.8-2.8-2.6l-0.2-0.2C206.09,931.72,207.29,932.72,208.49,933.32z"
}), React.createElement("polygon", {
  className: "st0",
  points: "319.29,244.52 319.29,248.12 328.69,253.32 331.69,251.52  "
}), React.createElement("polygon", {
  className: "st0",
  points: "341.29,259.92 334.49,263.92 334.49,301.92 341.29,297.72  "
}), React.createElement("polygon", {
  className: "st0",
  points: "328.69,253.32 331.69,251.52 331.69,251.52  "
}), React.createElement("path", {
  className: "st0",
  d: "M333.69,257.12l3.8-2.2l-6-3.4l-3,1.8l3,1.8C332.49,255.72,333.09,256.32,333.69,257.12z"
}), React.createElement("polygon", {
  className: "st0",
  points: "334.29,263.92 341.09,260.12 341.09,260.12  "
}), React.createElement("path", {
  className: "st0",
  d: "M334.49,260.32v3.6l6.8-4v-2.6l-3.8-2.2l-3.8,2.2C334.29,258.32,334.49,259.32,334.49,260.32z"
}), React.createElement("polygon", {
  className: "st0",
  points: "341.29,331.92 341.29,311.92 334.49,315.72 334.49,328.12  "
}), React.createElement("path", {
  className: "st0",
  d: "M341.29,297.72l-6.8,4v7c2.2-1.4,4.6-2.6,6.8-4V297.72z"
}), React.createElement("path", {
  className: "st0",
  d: "M341.29,304.72c-2.2,1.4-4.6,2.6-6.8,4v7l6.8-4V304.72z"
}), React.createElement("rect", {
  x: 325.49,
  y: 240.92,
  className: "st0",
  width: 0,
  height: 14
}), React.createElement("path", {
  className: "st0",
  d: "M331.69,251.52L331.69,251.52L331.69,251.52z"
}), React.createElement("rect", {
  x: 334.49,
  y: 249.92,
  className: "st0",
  width: 0,
  height: 7
}), React.createElement("rect", {
  x: 339.29,
  y: 253.92,
  className: "st0",
  width: 0,
  height: 4.4
}), React.createElement("path", {
  className: "st1",
  d: "M310.49,256.92l6,3.6l6-3.4l-9-5.4v-10.4l-1.6-0.8l-4.6,2.6v8.6C307.49,253.72,308.49,255.72,310.49,256.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M307.49,233.92v1.8l0.4-0.2C307.49,235.12,307.49,234.52,307.49,233.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M311.69,240.12l-1.6-0.8c-1.4-0.8-2.2-2.2-2.6-3.8l-0.4,0.2v7L311.69,240.12z"
}), React.createElement("polygon", {
  className: "st1",
  points: "328.69,267.52 322.49,270.72 322.49,308.92 328.69,305.12  "
}), React.createElement("polygon", {
  className: "st1",
  points: "317.89,261.52 321.09,255.72 321.09,255.72  "
}), React.createElement("polygon", {
  className: "st1",
  points: "322.49,256.92 316.29,260.12 322.49,263.92 328.69,260.32  "
}), React.createElement("polygon", {
  className: "st1",
  points: "322.49,270.72 328.49,267.12 328.49,267.12  "
}), React.createElement("polygon", {
  className: "st1",
  points: "328.69,260.32 328.69,260.32 322.49,263.92 322.49,263.92 322.49,270.72 328.69,267.52  "
}), React.createElement("path", {
  className: "st1",
  d: "M325.49,336.92l18.8,11c-2-1-3-3-3-5.2v-3.4l-12.8-7.4v-12.4l-6,3.4v8.8 C322.49,333.92,323.69,335.72,325.49,336.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M328.69,312.12v-7l-6,3.4v7C324.29,314.52,326.69,313.32,328.69,312.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M328.69,319.32v-7c-2,1.2-4,2.4-6,3.4v7L328.69,319.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M341.29,338.92v3.4c0,2.2,1.2,4.2,3,5.2c1,0.6,2,0.8,3,0.8s2-0.2,3-0.8c2-1,3-3,3-5.2v-3.4l-6,3.4 L341.29,338.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M347.49,259.92v34.6l6-3.4v-33.6l0,0l-3,1.8C349.69,259.52,348.49,259.92,347.49,259.92z"
}), React.createElement("polygon", {
  className: "st1",
  points: "347.49,342.52 353.49,338.92 353.49,331.92 353.49,304.72 347.49,308.32  "
}), React.createElement("path", {
  className: "st1",
  d: "M353.49,297.72v-7l-6,3.4v7C349.29,300.12,351.29,298.92,353.49,297.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M353.49,304.72v-7c-2,1.2-4,2.4-6,3.4v7L353.49,304.72z"
}), React.createElement("polygon", {
  className: "st1",
  points: "313.49,239.52 311.69,240.12 313.49,240.92  "
}), React.createElement("path", {
  className: "st1",
  d: "M317.89,229.92l-1.6-0.8c-1.8-1-4.2-1-6,0s-3,3-3,5.2c0,0.6,0.2,1,0.4,1.6L317.89,229.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M313.49,233.92l6-3.4l-1.6-0.8l-10.2,5.8c0.4,1.6,1.2,2.8,2.6,3.8l1.6,0.8l1.6-0.8 C313.49,239.52,313.49,233.92,313.49,233.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M347.49,259.92c1,0,2-0.4,3-0.8l3-1.8v-3.4c0-0.2-0.2-0.4-0.2-0.8l-5.8,3.4 C347.49,256.32,347.49,259.92,347.49,259.92z"
}), React.createElement("polygon", {
  className: "st1",
  points: "347.49,256.32 353.09,253.12 353.09,253.12  "
}), React.createElement("path", {
  className: "st1",
  d: "M347.49,256.32l5.8-3.4c0-0.8-0.2-1.6-0.6-2.2l-5.2,3V256.32z"
}), React.createElement("polygon", {
  className: "st1",
  points: "343.69,244.52 324.09,233.32 317.89,236.52 337.49,248.12  "
}), React.createElement("polygon", {
  className: "st1",
  points: "317.89,236.52 324.09,233.32 319.29,230.72 313.49,233.92  "
}), React.createElement("polygon", {
  className: "st1",
  points: "337.49,248.12 343.69,244.52 343.69,244.52  "
}), React.createElement("path", {
  className: "st1",
  d: "M344.29,248.32l3-1.8l-3.8-2.2l-6,3.4l4.6,2.6C342.89,249.92,343.49,248.92,344.29,248.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M342.29,250.72l1.4,0.8l6-3.4l-2.4-1.4l-3,1.8C343.49,248.92,342.89,249.92,342.29,250.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M347.49,253.92l5.2-3c-0.6-1-1.2-1.6-2.2-2.2l-0.8-0.4l-6,3.4L347.49,253.92z"
}), React.createElement("polygon", {
  className: "st1",
  points: "319.29,248.12 319.29,244.52 313.49,240.92 313.49,251.52 322.49,256.92 328.69,253.32  "
}), React.createElement("polygon", {
  className: "st1",
  points: "334.49,263.92 328.69,267.52 328.69,305.12 334.49,301.92  "
}), React.createElement("polygon", {
  className: "st1",
  points: "323.69,258.12 327.29,251.92 327.29,251.92  "
}), React.createElement("path", {
  className: "st1",
  d: "M333.69,257.12c-0.6-1-1.2-1.6-2.2-2.2l-3-1.8l-6,3.4l6,3.4L333.69,257.12z"
}), React.createElement("polygon", {
  className: "st1",
  points: "328.49,267.52 334.49,263.92 334.49,263.92  "
}), React.createElement("path", {
  className: "st1",
  d: "M334.49,260.32c0-1-0.2-2.2-0.8-3l-5.2,3l0,0v7l6-3.6C334.49,263.92,334.49,260.32,334.49,260.32z"
}), React.createElement("polygon", {
  className: "st1",
  points: "341.29,338.92 341.29,331.92 334.49,328.12 334.49,315.72 328.69,319.32 328.69,331.52  "
}), React.createElement("path", {
  className: "st1",
  d: "M334.49,301.92l-6,3.6v7c2-1.2,4-2.4,6-3.6V301.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M334.49,315.72v-7c-2,1.2-4,2.4-6,3.6v7L334.49,315.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M343.69,258.72l-2.4,1.4v38l6-3.6v-34.6c-1,0-2.2-0.4-3-0.8L343.69,258.72z"
}), React.createElement("polygon", {
  className: "st1",
  points: "341.89,260.32 342.89,258.12 342.89,258.12  "
}), React.createElement("polygon", {
  className: "st1",
  points: "341.29,257.12 341.29,259.92 343.69,258.72  "
}), React.createElement("polygon", {
  className: "st1",
  points: "347.49,308.32 341.29,311.92 341.29,331.92 341.29,338.92 347.49,342.52  "
}), React.createElement("path", {
  className: "st1",
  d: "M341.29,304.72c2-1.2,4-2.4,6-3.6v-7l-6,3.6V304.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M347.49,308.32v-7c-2,1.2-4,2.4-6,3.6v7L347.49,308.32z"
}), React.createElement("polygon", {
  className: "st1",
  points: "319.29,244.52 331.69,251.52 337.49,248.12 317.89,236.52 313.49,239.52 313.49,240.92  "
}), React.createElement("polygon", {
  className: "st1",
  points: "313.49,233.92 313.49,239.52 317.89,236.52  "
}), React.createElement("polygon", {
  className: "st1",
  points: "332.89,252.72 336.29,246.92 336.29,246.92  "
}), React.createElement("path", {
  className: "st1",
  d: "M337.49,255.12l4-2.4c0.2-0.8,0.2-1.4,0.6-2l-4.6-2.6l-6,3.4L337.49,255.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M341.29,253.92c0-0.4,0.2-0.6,0.2-1l-4,2.4l3.8,2.2V253.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M344.29,258.92c1,0.6,2,0.8,3,0.8v-3.4l-3.8,2.2L344.29,258.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M342.29,250.72c-0.4,0.6-0.4,1.4-0.6,2l2-1.2L342.29,250.72z"
}), React.createElement("polygon", {
  className: "st1",
  points: "343.69,258.72 347.49,256.32 347.49,256.32  "
}), React.createElement("path", {
  className: "st1",
  d: "M341.29,257.12L341.29,257.12l2.4,1.4l3.8-2.2v-2.6l-3.8-2.2l-2,1.2c0,0.4-0.2,0.6-0.2,1v3.4 C341.69,257.12,341.29,257.12,341.29,257.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M341.69,450.72c1.2,2,3.2,3,5.2,3c1,0,2-0.2,3-0.8l189.6-109.4c2.8-1.6,3.8-5.4,2.2-8.2 c-1.8-2.8-5.4-4-8.2-2.2l-189.4,109.4C341.09,444.32,339.89,447.72,341.69,450.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M533.49,410.12l-189.4,109.4c-2.8,1.6-3.8,5.4-2.2,8.2c1.2,2,3.2,3,5.2,3c1,0,2-0.2,3-0.8l189.4-109.4 c2.8-1.6,3.8-5.4,2.2-8.2C540.09,409.52,536.29,408.32,533.49,410.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M479.09,513.92l-135,78c-2.8,1.8-3.8,5.4-2.2,8.2c1.2,2,3.2,3,5.2,3c1,0,2-0.2,3-0.8l135-78 c2.8-1.6,3.8-5.4,2.2-8.2C485.49,512.92,481.69,512.12,479.09,513.92z"
}), React.createElement("polygon", {
  className: "st1",
  points: "466.29,225.72 466.29,209.52 460.49,213.12 460.49,229.32  "
}), React.createElement("path", {
  className: "st1",
  d: "M466.29,226.52v-1l-6,3.4l0,0l3-1.6C464.29,226.92,465.49,226.52,466.29,226.52z"
}), React.createElement("polygon", {
  className: "st1",
  points: "488.09,250.72 488.09,250.72 487.89,250.72  "
}), React.createElement("path", {
  className: "st1",
  d: "M466.29,209.52v-7c-2,1.2-4,2.4-6,3.4v7L466.29,209.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M460.49,202.72v3.6c2-1.2,4-2.4,6-3.4l0,0l19-11c0,8.2,0,15.8,0,23.2l6-3.4v-20c0-2.2-1.2-4.2-3-5.2 c-1.8-1-4.2-1-6,0l-19,10.8C461.29,198.32,460.49,200.32,460.49,202.72z"
}), React.createElement("rect", {
  x: 488.09,
  y: 250.72,
  className: "st1",
  width: 0,
  height: 0.2
}), React.createElement("path", {
  className: "st1",
  d: "M485.09,238.32l3.4,2.2c1.6,1.2,2.6,3,2.6,5.2l0,0v-20.2l-6,3.4C485.09,231.92,485.09,235.12,485.09,238.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M485.09,221.52c2-1.2,4-2.4,6-3.4v-7l-6,3.4C485.09,216.92,485.09,219.52,485.09,221.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M485.09,228.72l6-3.4v-7c-2,1.2-4,2.4-6,3.4C485.09,223.92,485.09,226.32,485.09,228.72z"
}), React.createElement("polygon", {
  className: "st1",
  points: "472.49,222.12 472.49,205.92 466.29,209.52 466.29,225.72  "
}), React.createElement("path", {
  className: "st1",
  d: "M469.89,227.72l2.4,1.6c0,0,0.2,0,0.2-0.2v-7l-6,3.6v1C467.49,226.52,468.69,226.92,469.89,227.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M476.29,232.12l-4-2.8v-0.4c0,0-0.2,0-0.2,0.2L476.29,232.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M472.49,205.92L472.49,205.92l6.8-4v16.2l6-3.6c0-7.4,0-14.8,0-23.2c-6.4,3.6-12.6,7.2-19,11v7L472.49,205.92z "
}), React.createElement("path", {
  className: "st1",
  d: "M479.29,233.92l6,4c0-3.2,0-6.4,0-9.4l-6,3.6V233.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M479.29,225.12c2-1.2,4-2.4,6-3.6c0-2.2,0-4.6,0-7l-6,3.6V225.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M479.29,232.12l6-3.6c0-2.4,0-4.6,0-7c-2,1.2-4,2.4-6,3.6V232.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M466.29,202.72L466.29,202.72c6.4-3.6,12.6-7.2,19-11L466.29,202.72z"
}), React.createElement("polygon", {
  className: "st1",
  points: "371.09,280.72 371.09,280.72 389.29,270.12  "
}), React.createElement("path", {
  className: "st1",
  d: "M461.09,235.72c-0.6-1-0.8-2-0.8-3v-3.4l-71,41l-18.2,10.6v7c23.4-13.6,46.8-27,70.2-40.6L461.09,235.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M371.09,287.72L371.09,287.72l70.2-40.6C417.89,260.72,394.49,273.92,371.09,287.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M491.29,245.72C491.29,245.72,491.09,245.72,491.29,245.72c0,0.6-0.4,1.4-0.6,2 C491.09,246.92,491.09,246.32,491.29,245.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M489.89,249.32c-0.4,0.6-0.8,1.2-1.6,1.6c1-0.6,1.6-1.2,2.2-2.2l0,0 C490.49,248.92,489.89,248.92,489.89,249.32z"
}), React.createElement("polygon", {
  className: "st1",
  points: "371.09,280.72 365.09,283.92 365.09,283.92  "
}), React.createElement("path", {
  className: "st1",
  d: "M371.09,280.72l-6,3.4c0,2.4,0,4.6,0,7c2-1.2,4-2.4,6-3.4V280.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M371.09,287.72c-2,1.2-4,2.4-6,3.4l0,0L371.09,287.72L371.09,287.72z"
}), React.createElement("polygon", {
  className: "st1",
  points: "362.29,285.72 362.29,285.72 365.09,283.92 365.09,283.92  "
}), React.createElement("path", {
  className: "st1",
  d: "M490.49,248.72C490.49,248.32,490.49,248.32,490.49,248.72c0.2-0.2,0.2-0.6,0.2-0.8c0.2-0.6,0.6-1.4,0.6-2.2 l0,0C491.09,246.52,491.09,247.72,490.49,248.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M487.89,250.72c-0.8,0.4-1.8,0.8-2.8,0.8c-1.2,0-2.4-0.4-3.4-1l-2.4-1.6c-38.2,22-76.2,44-114.2,66 c0-6,0-11.4,0-16.8l-6,3.6v13.2c0,2.2,1.2,4.2,3,5.2c1,0.6,2,0.8,3,0.8s2-0.2,3-0.8L487.89,250.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M488.09,250.72L488.09,250.72c0.8-0.4,1.2-1,1.6-1.6C489.29,249.92,488.69,250.32,488.09,250.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M365.09,283.92l-3,1.8c-1.8,1-3,3-3,5.2v3.4c2-1.2,4-2.4,6-3.6C365.09,288.92,365.09,286.32,365.09,283.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M365.09,298.12c0-2.4,0-4.6,0-7l0,0c-2,1.2-4,2.4-6,3.6v7L365.09,298.12z"
}), React.createElement("rect", {
  x: 478.49,
  y: 232.72,
  className: "st1",
  width: 0,
  height: 1.8
}), React.createElement("path", {
  className: "st1",
  d: "M477.89,233.12l-1.4-0.8L477.89,233.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M466.29,226.52c-1,0-2,0.2-3,0.8l-3,1.8v3.4c0,1,0.4,2,0.8,3l5.2-3C466.29,232.72,466.29,226.52,466.29,226.52 z"
}), React.createElement("path", {
  className: "st1",
  d: "M490.49,248.72c-0.2,0.2-0.4,0.4-0.6,0.6C489.89,248.92,490.49,248.92,490.49,248.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M479.29,248.92l2.4,1.6c1,0.6,2.2,1,3.4,1c1,0,2-0.2,2.8-0.8h0.2c0.6-0.4,1.2-1,1.6-1.6 c0.2-0.2,0.4-0.4,0.6-0.6c0.6-0.8,0.8-2,0.8-3c0-2-1-4-2.6-5.2l-3.4-2.2c0,2.4,0,4.8,0,7.4 C483.49,246.52,481.29,247.72,479.29,248.92z"
}), React.createElement("polygon", {
  className: "st1",
  points: "471.89,236.32 479.29,241.32 479.29,233.92 477.89,233.12  "
}), React.createElement("path", {
  className: "st1",
  d: "M466.29,226.52v6l0,0c2-1.2,3.8-2.2,5.8-3.4l-2.4-1.6C468.69,226.92,467.49,226.52,466.29,226.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M476.29,232.12l-4.2-2.8c-2,1.2-3.8,2.2-5.8,3.4l5.6,3.8l5.8-3.4L476.29,232.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M479.29,233.92v7.4l6,4.2c0-2.6,0-4.8,0-7.4L479.29,233.92L479.29,233.92z"
}), React.createElement("polygon", {
  className: "st1",
  points: "371.09,294.52 466.09,239.92 466.09,239.92  "
}), React.createElement("polygon", {
  className: "st1",
  points: "473.69,245.12 473.69,245.12 467.89,240.92  "
}), React.createElement("path", {
  className: "st1",
  d: "M441.69,246.92c6.6-3.8,13.2-7.6,19.6-11.4l0,0L441.69,246.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M462.89,237.72c-0.8-0.6-1.4-1.2-1.8-2c-6.6,3.8-13.2,7.6-19.6,11.4l-70.2,40.6v7l94.8-54.8L462.89,237.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M479.29,248.92l-5.6-3.8l0,0l0,0l-102.6,59.2v-9.8l0,0l-6,3.4c0,5.4,0,10.8,0,16.8 C403.09,292.72,441.29,270.72,479.29,248.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M371.09,287.72l-6,3.4c0,2.4,0,4.6,0,7l6-3.4V287.72z"
}), React.createElement("polygon", {
  className: "st1",
  points: "479.29,241.32 471.89,236.32 466.09,239.92 466.09,239.92 466.09,239.92 467.89,240.92 473.69,245.12  479.29,241.92  "
}), React.createElement("path", {
  className: "st1",
  d: "M466.29,232.72l-5.2,3l0,0C462.89,234.52,464.49,233.72,466.29,232.72L466.29,232.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M461.09,235.72c0.4,0.8,1,1.6,1.8,2l3.2,2l5.8-3.4l-5.6-3.8C464.49,233.72,462.89,234.52,461.09,235.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M479.29,241.32v0.6l-5.4,3.2l5.6,3.8c2-1.2,3.8-2.2,5.8-3.4L479.29,241.32z"
}), React.createElement("path", {
  className: "st2",
  d: "M804.09,508.92c5.8,14.8,9,32.4,9,52c0,89.8-63.2,199.4-141,244.2c-16.6,9.6-32.8,15.6-48.2,18.2 c1.4,0,2.8,0,4.4-0.2c0.8,0,1.8-0.2,2.6-0.2c3.6-0.4,7-1,10.6-1.8c0.8-0.2,1.6-0.4,2.4-0.6c2.6-0.6,5.4-1.4,8-2.4 c2.2-0.8,4.4-1.6,6.6-2.4c2.6-1,5-2,7.6-3.2c1.2-0.4,2.2-1,3.2-1.6c3.8-1.8,7.6-3.8,11.4-6c18-10.4,35.4-24.4,51.8-41.8 c0.2-0.2,0.2-0.2,0.4-0.4c3.2-3.4,6.2-7,9.4-10.4c1.2-1.4,2.4-2.8,3.6-4.2c0.6-0.8,1.4-1.8,2-2.6c24.4-30.4,43.6-65.8,55.2-99.2 c1.2-3.4,2.4-6.8,3.4-10.2c0.4-1.4,0.8-2.8,1.2-4.2c1-3.6,2-7.4,2.8-11c0.8-3.4,1.6-6.8,2.2-10.2c0.4-1.8,0.6-3.4,1-5.2 c0.6-3,1-6.2,1.4-9.2c0.2-1,0.2-1.8,0.4-2.8c0.6-4.8,1-9.4,1.4-14.2c0.2-3,0.4-6,0.4-8.8c0-1.2,0-2.6,0-3.8 c-0.2-19.8-3.6-37.2-10-51.6C806.49,513.12,805.29,510.92,804.09,508.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M815.49,596.72c-0.4,3-1,6.2-1.4,9.2C814.49,602.92,815.29,599.92,815.49,596.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M669.69,811.52c-1,0.6-2.2,1-3.2,1.6C667.49,812.52,668.69,811.72,669.69,811.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M807.49,634.72c0.2-0.8,0.4-1.6,0.6-2.4c-0.4,1.4-0.8,2.8-1.2,4.2C806.89,635.92,807.29,635.52,807.49,634.72z "
}), React.createElement("path", {
  className: "st1",
  d: "M777.7,703.32c10.6-18.4,19.2-37.4,25.8-56.4c-11.6,33.4-30.8,69-55.2,99.2 C758.9,732.92,768.9,718.72,777.7,703.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M732.89,763.32C733.09,763.32,733.09,763.32,732.89,763.32L732.89,763.32 C732.89,763.72,732.89,763.32,732.89,763.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M746.29,748.72c-1.2,1.4-2.4,2.8-3.6,4.2C743.9,751.52,745.09,750.12,746.29,748.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M630.09,823.32c0.4,0,0.6-0.2,1-0.2c-1,0.2-1.8,0.2-2.6,0.2C628.9,823.32,629.29,823.32,630.09,823.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M813.09,611.32c-0.6,3.4-1.4,6.8-2.2,10.2C811.69,617.92,812.49,614.52,813.09,611.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M817.7,568.72c0-0.6,0-1,0-1.6c0,1.2,0,2.6,0,3.8C817.7,570.32,817.7,569.32,817.7,568.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M817.29,579.52c-0.2,4.8-0.8,9.4-1.4,14.2C816.49,589.12,816.89,584.32,817.29,579.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M658.9,815.92c-2.2,0.8-4.4,1.6-6.6,2.4C654.09,817.92,656.49,816.72,658.9,815.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M643.9,820.72c-0.8,0.2-1.6,0.4-2.4,0.6C642.49,821.32,643.09,820.92,643.9,820.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M806.89,560.92c0,88-61.8,195-138,239c-28.2,16.2-54.2,21.6-76.2,17.4c1,0.4,2,1,3.2,1.4s2.4,0.8,3.6,1.2 c1.8,0.6,3.6,1.2,5.6,1.6c1.2,0.2,2.2,0.6,3.4,0.8c3,0.6,6,0.8,9,1c0.8,0,1.8,0,2.6,0c1.2,0,2.4,0,3.6-0.2 c15.4-2.6,31.6-8.6,48.2-18.2c77.8-45,141-154.4,141-244.2c0-19.8-3.2-37.2-9-52c-4.2-7.6-9.4-14.2-15.4-19.2 c-0.8-0.6-1.6-1.2-2.4-1.8c-0.6-0.6-1.4-1-2-1.4C798.69,503.32,806.89,528.72,806.89,560.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M620.29,823.72c-0.8,0-1.8,0-2.6,0C618.69,823.72,619.29,823.72,620.29,823.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M786.29,487.72c0.8,0.6,1.6,1.2,2.4,1.8C787.89,488.92,787.29,488.32,786.29,487.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M608.69,822.72c-1.2-0.2-2.2-0.6-3.4-0.8C606.49,821.92,607.49,822.52,608.69,822.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M599.89,820.32c-1.2-0.4-2.4-0.8-3.6-1.2C597.49,819.32,598.69,819.92,599.89,820.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M801.09,560.92c0,86-60.6,190.8-135,233.8c-31.2,18-60.4,22.6-83.4,13.4c-1.2,0.2-2.6,0.2-3.8,0.2 c2.8,2.4,5.8,4.6,8.8,6.4l0.6,0.4l0,0c1.4,0.8,3,1.4,4.6,2.2c21.8,4.2,48-1.2,76.2-17.4c76.2-44,138-151,138-239 c0-32.4-8.4-57.8-22.8-74.6c-1.4-1-2.6-2-4.2-2.8l-0.6-0.4c-3.4-1.8-6.8-3.4-10.4-4.6c0.4,1,1,2,1.4,3 C790.29,496.92,801.09,524.52,801.09,560.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M779.89,483.32c-0.2,0-0.2-0.2-0.4-0.2l0.6,0.4C780.09,483.32,780.09,483.32,779.89,483.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M770.29,481.52c-0.4-1-0.8-2-1.4-3c-1.8-0.6-3.6-1.2-5.4-1.6l0,0C766.09,478.32,768.09,480.12,770.29,481.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M582.7,808.12c-2.6-1-5.2-2.2-7.6-3.6c1.2,1.4,2.6,2.6,4,3.8C580.29,808.32,581.49,808.32,582.7,808.12z"
}), React.createElement("path", {
  className: "st2",
  d: "M486.29,790.32c6,12,14,22.4,24.8,30.6c2.8,2.2,9,6,16,10c-2-3.4-4-7-5.8-10.8c-0.6-1.2-1.2-2.6-1.6-4 c-1.4-3.2-2.6-6.4-3.6-9.6c-0.6-1.8-1.2-3.6-1.8-5.4c-1.2-4-2.2-8.4-3.2-12.8c-0.6-3-1-6.2-1.6-9.4c-0.2-0.8-0.2-1.4-0.4-2.2 L486.29,790.32z"
}), React.createElement("path", {
  className: "st2",
  d: "M627.49,487.72c2.4-2.2,4.6-4.2,7-6.4c2.4-2.2,4.8-4.2,7.2-6.2c3.2-2.8,6.4-5.4,9.8-8c3-2.4,6.2-4.6,9.2-6.8 c1.4-1,2.8-2,4.2-3c5.2-3.6,10.4-6.8,15.8-10c0.2,0,0.4-0.2,0.4-0.4c0.2-0.2,0.4-0.2,0.6-0.4c20.4-11.8,42-20.2,63.4-22.8 c1.8-0.2,3.6-0.4,5.4-0.6c0.6,0,1.4,0,2-0.2c3.4-0.2,6.6-0.4,9.8-0.2l-11-6.4c-37-20-81.2-3.6-111.8,13.6 c-6.4,3.8-12.6,8-18.8,12.4v51.8C622.7,491.92,625.09,489.92,627.49,487.72z"
}), React.createElement("path", {
  className: "st2",
  d: "M583.9,537.12c1.6-2.2,3.2-4.2,4.8-6.4c2.4-3,4.6-6,7-9c1.6-2,3.2-4,4.8-5.8c0.4-0.4,0.8-1,1.2-1.4 c2.2-2.6,4.6-5.2,7-7.8v-55.2c-8.6,6.8-16.8,14.2-24.8,22L583.9,537.12L583.9,537.12z"
}), React.createElement("path", {
  className: "st2",
  d: "M507.29,747.92L507.29,747.92c0-0.4,0-0.8,0-1c0-2.2,0-4.2,0.2-6.4l-31.6,18.2c1.4,7,3.4,13.6,5.6,20 l26.4-15.2C507.49,758.72,507.29,753.32,507.29,747.92z"
}), React.createElement("path", {
  className: "st2",
  d: "M616.49,498.32c1.4-1.4,2.8-2.8,4.2-4.2v-51.8c-2,1.4-4,2.8-6,4.4v53.4 C615.29,499.52,616.09,498.92,616.49,498.32z"
}), React.createElement("path", {
  className: "st2",
  d: "M508.49,770.52l-24.8,14.2c0.8,1.8,1.8,3.6,2.6,5.4l23-13.2C509.09,774.52,508.69,772.72,508.49,770.52z"
}), React.createElement("path", {
  className: "st2",
  d: "M612.29,502.72c0.8-0.8,1.6-1.8,2.4-2.8v-53.4c-2,1.6-4,3.2-6,4.8v55.2 C609.89,505.32,611.09,504.32,612.29,502.72z"
}), React.createElement("path", {
  className: "st2",
  d: "M507.89,768.12c0-0.8,0-1.8-0.2-2.6c0-0.6,0-1.4-0.2-2l-26.4,15.2c0.8,2,1.4,3.8,2.2,5.8l24.8-14.2 C508.09,769.52,508.09,769.12,507.89,768.12z"
}), React.createElement("path", {
  className: "st2",
  d: "M473.69,746.32l34.4-20c0-0.4,0-0.6,0.2-1c0.4-5.4,1.2-10.8,2-16.2c0.4-2.4,0.8-4.8,1.2-7.2 c0.6-3.6,1.2-7,2-10.6c0.8-4.2,1.8-8.4,2.8-12.8c0.2-1,0.4-1.8,0.8-2.8c8.6-33,22.2-66.8,41-99.2c4.4-7.6,9-14.8,13.6-22v-68.6 c-38.4,41.6-69.6,95-86.6,151.8C474.89,670.72,469.29,710.52,473.69,746.32z"
}), React.createElement("path", {
  className: "st2",
  d: "M474.49,752.92c0.4,2.2,0.8,4.2,1.2,6.2l31.6-18.2c0-2.4,0-4.6,0.2-7L474.49,752.92z"
}), React.createElement("path", {
  className: "st2",
  d: "M577.7,479.52v66.4c1-1.4,1.8-2.6,2.8-4c0.2-0.2,0.2-0.4,0.4-0.6c1-1.4,1.8-2.8,2.8-4.2v-63.4 C581.69,475.32,579.89,477.52,577.7,479.52z"
}), React.createElement("path", {
  className: "st2",
  d: "M508.09,726.52l-34.4,20c0.2,2.2,0.6,4.4,0.8,6.4l33-19c0.2-1.8,0.4-3.6,0.4-5.4 C507.89,727.72,507.89,726.92,508.09,726.52z"
}), React.createElement("path", {
  className: "st2",
  d: "M571.49,554.52c2-3,4-5.8,6-8.8v-66.4c-2,2.2-4,4.4-6,6.6V554.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M636.49,424.52c34.8-19.6,80-33.8,117.8-13.6l22.4,12.8c10,1.6,19.6,4.8,28.4,9.4l-0.2-0.2l-47.6-27.4 c-42-22.6-90.4-5-123.6,13.6l0,0c-4.2,2.6-8.6,5.2-12.8,8v7.4C626.09,431.32,631.29,427.72,636.49,424.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M535.69,842.92c-11.8-6.8-23.6-13.8-28.4-17.2c-11.6-8.8-20.2-19.8-26.4-32.4l-5.2,3c6.8,13.2,16,24.8,28.2,34 c7,5.4,27.8,17,43,25.6l10.4,6c0.2,0.2,0.4,0,0.6,0.2C549.69,856.92,542.29,850.52,535.69,842.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M464.49,765.52c1.6,6.8,3.6,13.4,6.2,19.6l5.4-3.2c-2.4-6.4-4.4-13-6-19.8L464.49,765.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M583.9,464.72c8-7.6,16.2-14.6,24.8-21.2v-7.6c-8.6,6.4-16.8,13.2-24.8,20.6V464.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M478.09,787.92l-5.4,3c0.8,1.8,1.8,3.6,2.8,5.4l5.2-3C479.89,791.52,479.09,789.52,478.09,787.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M614.89,439.32c2-1.4,4-3,6-4.4v-7.2c-2,1.4-4,2.8-6,4.2V439.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M470.49,785.32c0.8,2,1.4,3.8,2.4,5.6l5.4-3c-0.8-1.8-1.6-3.8-2.2-5.6L470.49,785.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M608.69,443.72c2-1.6,4-3,6-4.4v-7.4c-2,1.4-4,2.8-6,4.4V443.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M473.49,634.12c-11.4,37.4-17.2,80.6-11.4,118.8l5.8-3.4c-5.4-38.8,1.8-81.6,11.4-113.6 c17.2-56.8,49.6-114.2,92.4-159v-8.6C527.7,512.92,492.49,571.72,473.49,634.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M463.09,759.12c0.4,2,0.8,4.2,1.4,6.2l5.6-3.2c-0.4-2-0.8-4.2-1.2-6.4L463.09,759.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M577.7,470.72c2-2,4-4,6-6v-8.2c-2,1.8-4,3.8-6,5.8V470.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M461.89,752.92c0.4,2.2,0.8,4.2,1.2,6.4l5.8-3.2c-0.4-2.2-0.8-4.2-1.2-6.4L461.89,752.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M571.49,476.92c2-2,4-4,6-6v-8.4c-2,2-4,3.8-6,6V476.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M516.09,806.52c1.2,3.4,2.4,6.6,3.6,9.6C518.49,812.92,517.29,809.92,516.09,806.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M639.69,430.12c30.6-17.2,74.8-33.4,111.8-13.6l11,6.4c5,0,9.8,0.6,14.4,1.2l-22.4-12.8 c-37.8-20.2-83-6-117.8,13.6c-5.4,3.2-10.6,6.6-15.8,10.2v7.4C626.89,438.12,633.09,433.92,639.69,430.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M527.29,830.72c-7-4.2-13.2-7.8-16-10c-10.8-8.2-18.8-18.6-24.8-30.6l-5.4,3c6.4,12.4,15,23.6,26.4,32.4 c4.8,3.6,16.6,10.6,28.4,17.2c-5.6-6.8-10.4-14.4-14.4-22.8C523.09,823.92,525.09,827.52,527.29,830.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M511.09,788.32c1,4.4,2,8.6,3.2,12.8C513.09,796.92,511.89,792.92,511.09,788.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M620.69,494.32c2.2-2.2,4.4-4.4,6.6-6.6C625.09,489.92,622.7,491.92,620.69,494.32L620.69,494.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M660.29,460.12c-3.2,2.2-6.2,4.6-9.2,6.8C654.29,464.72,657.49,462.52,660.29,460.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M680.49,447.12c-5.4,3.2-10.6,6.4-15.8,10C670.09,453.72,675.29,450.12,680.49,447.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M745.09,423.92c-21.4,2.6-43,11-63.4,22.8C703.69,433.92,725.09,426.32,745.09,423.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M641.49,475.12c-2.4,2-4.8,4.2-7.2,6.2C636.49,479.32,638.9,476.92,641.49,475.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M752.7,423.12c-0.6,0-1.4,0-2,0.2C751.29,423.12,751.69,423.12,752.7,423.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M509.69,779.12c-0.2-0.8-0.2-1.4-0.2-2.2l0,0C509.29,777.72,509.29,778.12,509.69,779.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M588.69,530.72c2.4-3,4.6-6,7-9C593.49,524.72,591.09,527.92,588.69,530.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M507.49,740.72c0,2.2-0.2,4.2-0.2,6.4C507.29,745.12,507.49,742.92,507.49,740.72L507.49,740.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M583.9,473.72c8-7.8,16.4-15.2,24.8-22v-8c-8.6,6.6-16.8,13.6-24.8,21.2V473.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M608.69,506.92c-2.4,2.6-4.8,5.2-7,7.8c-0.4,0.4-0.8,1-1.2,1.4C603.09,512.92,605.69,510.12,608.69,506.92 L608.69,506.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M507.29,747.92c0,5.2,0.2,10.4,0.6,15.6l0,0C507.49,758.72,507.29,753.32,507.29,747.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M469.89,762.12c1.4,6.8,3.6,13.4,6,19.8l5.4-3.2c-2.4-6.4-4.2-13-5.6-20L469.89,762.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M616.49,498.32c1.4-1.4,2.8-2.8,4.2-4.2l0,0C619.29,495.32,617.89,496.92,616.49,498.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M483.69,784.52l-5.4,3c0.8,1.8,1.8,3.6,2.8,5.4l5.4-3C485.49,788.32,484.29,786.72,483.69,784.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M508.49,770.52c0.2,2.2,0.6,4.2,1,6.4l0,0C509.09,774.52,508.69,772.72,508.49,770.52L508.49,770.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M620.69,442.52v-7.4c-2,1.4-4,2.8-6,4.4v7.4C616.49,445.12,618.9,443.92,620.69,442.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M508.49,770.52L508.49,770.52c0-0.8-0.2-1.4-0.2-2.2C508.09,769.12,508.09,769.52,508.49,770.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M612.29,502.72c-1.2,1.2-2.4,2.6-3.6,3.8v0.2C609.89,505.72,611.09,504.32,612.29,502.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M608.69,451.52c2-1.6,4-3.2,6-4.8v-7.4c-2,1.4-4,2.8-6,4.4V451.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M507.89,763.72c0,0.6,0,1.4,0.2,2C507.89,765.12,507.89,764.32,507.89,763.72L507.89,763.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M481.29,779.12l-5.4,3.2c0.8,2,1.4,3.8,2.2,5.6l5.4-3C482.89,782.92,482.29,780.72,481.29,779.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M511.29,701.72c0.6-3.6,1.4-7,2-10.6C512.7,694.72,511.89,698.32,511.29,701.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M467.89,749.52l5.8-3.4c-4.4-35.6,1.4-75.4,11.4-108.6c17.2-56.6,48.2-110,86.6-151.8v-9 c-43,44.8-75.4,102.4-92.4,159C469.69,667.92,462.49,710.92,467.89,749.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M516.49,678.72c0.2-1,0.4-1.8,0.8-2.8C516.69,676.72,516.49,677.72,516.49,678.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M508.09,725.52c0.4-5.4,1.2-10.8,2-16.2C509.29,714.52,508.69,720.12,508.09,725.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M577.7,479.52c2-2,4-4,6-6v-8.6c-2,2-4,4-6,6V479.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M507.89,733.72L507.89,733.72c-0.4,2.6-0.2,5-0.4,7.2h0.2C507.49,738.32,507.49,735.92,507.89,733.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M469.09,755.92c0.4,2.2,0.6,4.2,1.2,6.4l5.8-3.4c-0.4-2-0.8-4.2-1.2-6.2L469.09,755.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M580.49,541.72c0.2-0.2,0.2-0.4,0.4-0.6C580.69,541.52,580.49,541.72,580.49,541.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M507.49,733.72L507.49,733.72c0.4-2,0.2-3.8,0.4-5.4C507.89,730.12,507.49,731.72,507.49,733.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M571.49,476.92v9c2-2.2,4-4.4,6-6.6v-8.6C575.69,472.72,573.69,474.72,571.49,476.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M467.89,749.52c0.2,2.2,0.8,4.2,1.2,6.4l5.6-3.2c-0.4-2.2-0.6-4.4-0.8-6.4L467.89,749.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M588.49,815.52C588.49,815.52,588.49,815.32,588.49,815.52l-0.6-0.4c0.2,0,0.2,0.2,0.4,0.2 C588.09,815.32,588.49,815.32,588.49,815.52z"
}), React.createElement("path", {
  className: "st0",
  d: "M666.29,475.92c23.6-13.6,46.4-20.2,67-19.6c-0.2-0.2-0.6-0.4-0.8-0.6c-2.8-1.8-3.8-5.4-2.2-8.2 c1.8-3,5.4-3.8,8.2-2.2l47,27.2c0.2,0,0.2,0.2,0.4,0.2s0.2,0.2,0.4,0.2l2,1.2c1.8,1.2,3.4,2.6,5.2,3.8c1,0.8,2,1.4,3,2.2 c9.8,8.2,17,18.6,22.2,30.2l0,0l0,0c1.8,4,3.4,8.2,4.6,12.4c0,0.2,0.2,0.4,0.2,0.6c2.6,8.6,4.4,17.4,5.2,26.8 c0.2,2.4,0.4,4.6,0.6,7c0.2,2,0.2,3.8,0.2,5.8c0,1.8,0.2,3.6,0.2,5.4c0,9-0.8,18.4-2,27.8c0,0.2,0,0.2,0,0.4c-0.4,3.6-1,7.2-1.6,11 c-0.4,2-0.8,3.8-1.2,5.8c-0.6,3.2-1.2,6.2-2,9.4c-1.2,5-2.4,9.8-3.8,14.6c0,0.2-0.2,0.4-0.2,0.8c0,0.2-0.2,0.4-0.2,0.4 c-0.4,1.4-0.8,2.8-1.2,4c-1.2,3.8-2.6,7.6-3.8,11.2c-0.4,1-0.6,1.8-1,2.8c-0.8,2.4-1.8,4.6-2.8,7c-6,15.4-13.4,30.6-22,45.6 c-12.2,21.4-26.6,40.8-42.4,58.2c-0.6,0.8-1.4,1.6-2,2.4c-0.6,0.6-1.2,1.2-1.6,1.8c-1.4,1.4-2.8,2.6-4,4c-2.6,2.6-5.2,5.4-8,7.8 c-1,1-2,1.8-3,2.6c-3.8,3.4-7.6,6.8-11.4,9.8c-0.2,0.2-0.4,0.4-0.6,0.6c-8.8,7.2-18,13.4-27.4,18.8c-0.2,0-0.2,0.2-0.4,0.2 c0,0-0.2,0-0.2,0.2c-4,2.4-8.2,4.4-12.2,6.4c-1.2,0.6-2.2,1-3.4,1.6c-3,1.4-6,2.6-9,3.6c-2.2,0.8-4.2,1.6-6.4,2.2 c-1,0.4-1.8,0.8-2.8,1c-7.4,2.2-14.6,3.6-21.6,4.4c-0.2,0-0.2,0-0.4,0h-0.2c-3.2,0.4-6.2,0.6-9.2,0.6c-7.2,0-14-0.8-20.6-2.6 c-6.2-1.6-12.2-4-17.8-7.2c-0.4-0.2-0.6-0.4-1-0.4c0,0,0,0-0.2,0l-47.4-27.4c0,0,0,0-0.2-0.2l-2.2-1.4c-2.8-1.6-3.8-5.4-2.2-8.2 c1.6-2.8,5.4-3.8,8.2-2.2l3.2,1.8l0,0c-4.4-7.2-8-15.2-10.6-24l-10.4,6c0.2,2.4,0.6,4.6,1,7c0.4,2.2,0.6,4.4,1,6.6 c0.8,4.6,2,9.2,3.2,13.4c0.4,1.2,0.8,2.4,1.2,3.6c1.2,3.4,2.4,6.6,3.6,9.8c0.4,1,0.8,2,1.2,3c1.8,3.8,3.6,7.4,5.8,10.8 c0.8,1.2,1.4,2.2,2.2,3.2c1.4,2,2.8,4,4.4,6c1.2,1.6,2.6,3.2,4,4.6c1,1.2,2.2,2.2,3.4,3.2c2.2,2.2,4.6,4.2,7,6 c2.4,1.8,5,3.8,7.6,5.4c30.4,17.4,71,13.2,114.8-12c44.6-25.8,86.8-70.4,118.4-125.2c31.8-55,49.2-113.6,49.2-165.2 c0-50.4-16.8-87.8-47-105.4c-1.4-0.8-2.8-1.4-4.4-2c-3.4-1.6-6.8-3-10.2-4.2l0,0c-4-1.4-8-2.2-12.2-3l0,0c-3.6-0.6-7.4-1-11.2-1.2 c-0.6,0-1.2-0.2-2-0.2c-3.6,0-7.2,0-10.8,0.4c-1.6,0.2-3.4,0.4-5,0.6s-3,0.4-4.6,0.6c-17.2,3-35.4,10-54.4,20.8 c-4.6,2.8-9.4,5.8-14,8.8c-2.6,1.8-5,3.6-7.6,5.4c-1.6,1.2-3.2,2.4-5,3.6c-10,7.6-19.6,16-28.4,24.6c-1.4,1.4-2.8,2.6-4,4 c-0.6,0.6-1.4,1.4-2,2C638.9,494.32,652.29,484.32,666.29,475.92z"
}), React.createElement("path", {
  className: "st0",
  d: "M519.89,733.72c-0.2,4.8-0.6,9.6-0.6,14.4c0,3,0.2,6,0.4,9l8.4-4.8c-1.4-6.8-2-14.2-2.4-21.8L519.89,733.72z"
}), React.createElement("path", {
  className: "st0",
  d: "M520.09,763.72c0.2,2.2,0.4,4.4,0.6,6.6l10.4-6c-0.6-2-1-4-1.6-6.2L520.09,763.72z"
}), React.createElement("path", {
  className: "st0",
  d: "M527.89,751.92l-8.4,4.8c0,2.2,0.2,4.6,0.2,6.8l9.6-5.6C528.9,756.32,528.49,754.12,527.89,751.92z"
}), React.createElement("path", {
  className: "st0",
  d: "M525.29,716.52c0.2-14.8,2.2-30,5.6-45.4c-0.2,1-0.6,2-0.8,3c-1,3.4-1.8,6.6-2.6,10c-0.6,2-1,4.2-1.4,6.2 c-1.2,5.8-2.4,11.6-3.4,17.2c0,0.2,0,0.4-0.2,0.8c-0.6,3.6-0.8,7-1.2,10.4L525.29,716.52z"
}), React.createElement("path", {
  className: "st0",
  d: "M520.29,726.32c-0.2,2.4-0.4,4.8-0.4,7.2l5.6-3.2c-0.2-2.2-0.2-4.4-0.2-6.8L520.29,726.32z"
}), React.createElement("path", {
  className: "st0",
  d: "M525.29,716.52l-4,2.4c-0.2,2.6-0.6,5-0.8,7.6l4.8-2.8c0-1-0.2-2-0.2-3.2 C525.09,719.12,525.29,717.92,525.29,716.52z"
}), React.createElement("path", {
  className: "st0",
  d: "M827.7,596.52c0,0.2,0,0.2,0,0.4C827.7,596.72,827.7,596.72,827.7,596.52z"
}), React.createElement("path", {
  className: "st0",
  d: "M829.29,557.52c0.2,2,0.2,3.8,0.2,5.8C829.69,561.32,829.29,559.32,829.29,557.52z"
}), React.createElement("path", {
  className: "st0",
  d: "M823.69,523.72c2.6,8.2,4.2,17.2,5.2,26.8C827.89,540.92,826.29,531.92,823.69,523.72z"
}), React.createElement("path", {
  className: "st0",
  d: "M726.69,786.52c-3.8,3.4-7.6,6.8-11.4,9.8C719.09,793.12,723.09,789.92,726.69,786.52z"
}), React.createElement("path", {
  className: "st0",
  d: "M812.7,656.72c-0.8,2.4-1.8,4.6-2.8,7C811.09,661.52,811.89,659.12,812.7,656.72z"
}), React.createElement("path", {
  className: "st0",
  d: "M653.09,830.72c1-0.2,1.8-0.6,2.8-1c-8.2,2.8-16.4,4.6-24.4,5.4C638.69,834.52,645.49,833.12,653.09,830.72z"
}), React.createElement("path", {
  className: "st0",
  d: "M818.9,510.32c1.8,4,3.4,8,4.6,12.4C821.89,518.72,820.49,514.32,818.9,510.32z"
}), React.createElement("path", {
  className: "st0",
  d: "M745.49,767.72c-0.6,0.8-1.4,1.6-2,2.4C744.09,769.12,745.09,768.32,745.49,767.72z"
}), React.createElement("path", {
  className: "st0",
  d: "M737.7,775.72c-2.6,2.6-5.2,5.4-8,7.8C732.49,781.32,735.29,778.32,737.7,775.72z"
}), React.createElement("path", {
  className: "st0",
  d: "M826.29,607.72c-0.4,2-0.8,3.8-1.2,5.8C825.29,611.72,825.69,609.52,826.29,607.72z"
}), React.createElement("path", {
  className: "st0",
  d: "M582.29,825.72c0.4,0.2,0.6,0.4,1,0.4C582.7,825.92,582.49,825.72,582.29,825.72L582.29,825.72z"
}), React.createElement("path", {
  className: "st0",
  d: "M714.89,796.72c-9,7.2-18,13.4-27.4,18.8C696.69,810.32,706.09,804.12,714.89,796.72z"
}), React.createElement("path", {
  className: "st0",
  d: "M671.29,824.12c-3,1.4-6,2.6-9,3.6C665.29,826.52,668.09,825.32,671.29,824.12z"
}), React.createElement("path", {
  className: "st0",
  d: "M745.09,457.72c-3-2.6-6.2-4.8-9.6-7l13.2,7.6c7,1.6,13.6,4,19.8,7.4c6,1.6,11.6,3.8,17,6.8l-47-27.2 c-3-1.6-6.6-0.8-8.2,2.2c-1.6,2.8-0.8,6.6,2.2,8.2c0.2,0.2,0.6,0.4,0.8,0.6C737.29,456.52,741.29,456.92,745.09,457.72z"
}), React.createElement("path", {
  className: "st0",
  d: "M601.09,833.32c6.6,1.6,13.4,2.6,20.6,2.6c3,0,6.2-0.2,9.2-0.6c-3.2,0.2-6.4,0.4-9.4,0.4 C614.29,835.72,607.7,835.12,601.09,833.32z"
}), React.createElement("path", {
  className: "st0",
  d: "M818.9,510.32c-5.2-11.6-12.4-22-22.2-30.2C805.49,488.12,813.09,498.32,818.9,510.32z"
}), React.createElement("path", {
  className: "st0",
  d: "M817.7,642.92c0.4-1.4,0.8-2.6,1.2-4c-1.6,5.2-3.2,10.2-5,15.4C815.29,650.32,816.49,646.52,817.7,642.92z"
}), React.createElement("path", {
  className: "st0",
  d: "M541.49,788.12L541.49,788.12L541.49,788.12z"
}), React.createElement("polygon", {
  className: "st0",
  points: "534.89,798.32 582.29,825.52 534.49,798.12  "
}), React.createElement("path", {
  className: "st0",
  d: "M822.89,622.92c-1.2,4.8-2.4,9.8-3.8,14.6C820.49,632.92,821.69,627.92,822.89,622.92z"
}), React.createElement("path", {
  className: "st0",
  d: "M788.09,474.32l-2-1.2c2.6,1.4,4.8,3.2,7.2,5C791.49,476.92,790.09,475.32,788.09,474.32z"
}), React.createElement("path", {
  className: "st0",
  d: "M686.69,815.92c-4.2,2.4-8.2,4.4-12.2,6.4C678.69,820.52,682.7,818.32,686.69,815.92z"
}), React.createElement("path", {
  className: "st0",
  d: "M735.29,450.72c3.6,2,6.6,4.4,9.6,7c1.2,0.2,2.4,0.4,3.6,0.6L735.29,450.72z"
}), React.createElement("path", {
  className: "st0",
  d: "M626.29,526.72c17.4-18.2,35.8-33.2,54.8-44.2c4-2.4,8.2-4.4,12.2-6.4c-7,2.8-14,6.2-21.2,10.2 c-18.2,10.6-35.6,24.8-51.4,41.4v5C622.7,530.72,624.29,528.92,626.29,526.72z"
}), React.createElement("path", {
  className: "st0",
  d: "M538.49,722.92l-1.2,0.6c0.2,6.4,0.6,12.6,1.4,18.4c-0.2-3.8-0.6-7.8-0.6-11.8 C538.09,727.72,538.49,725.32,538.49,722.92z"
}), React.createElement("path", {
  className: "st0",
  d: "M583.9,582.92c7.6-12.6,16-24.6,24.8-35.8v-5.6c-9,10.8-17.2,22.2-24.8,34.2V582.92z"
}), React.createElement("path", {
  className: "st0",
  d: "M620.69,532.92v-5c-2,2.2-4,4.4-6,6.6v5C616.49,537.52,618.9,535.32,620.69,532.92z"
}), React.createElement("path", {
  className: "st0",
  d: "M614.89,539.92v-5c-2,2.2-4,4.6-6,6.8v5.6C610.49,544.72,612.7,542.12,614.89,539.92z"
}), React.createElement("path", {
  className: "st0",
  d: "M571.49,604.32v-7.8c-19.4,36.2-32,75.8-34,112.6l1.8-1c1.6-15.4,4.6-31.4,9.6-47.8 C554.49,641.72,562.29,622.92,571.49,604.32z"
}), React.createElement("path", {
  className: "st0",
  d: "M538.9,715.52l-1.4,0.8c0,1.2-0.2,2.6-0.2,3.8c0,1,0.2,2,0.2,3.2l1.2-0.6 C538.69,720.52,538.69,717.92,538.9,715.52z"
}), React.createElement("path", {
  className: "st0",
  d: "M577.7,593.12c0.8-1.4,1.4-2.8,2.2-4c1.2-2.2,2.6-4.2,3.8-6.2v-7.2c-2,3.2-4,6.4-6,9.8V593.12z"
}), React.createElement("path", {
  className: "st0",
  d: "M539.29,708.12l-1.8,1c-0.2,2.4-0.2,4.8-0.4,7.2l1.4-0.8C538.9,713.12,539.09,710.72,539.29,708.12z"
}), React.createElement("path", {
  className: "st0",
  d: "M571.49,604.32c2-3.8,4-7.4,6-11.2v-7.6c-2.2,3.6-4,7.4-6,11V604.32z"
}), React.createElement("path", {
  className: "st0",
  d: "M668.9,481.32c25.8-15,49.8-20.4,70.6-18.2c0.8,0,1.6,0,2.4,0c-2.8-2.4-5.8-4.6-8.8-6.6 c-20.6-0.6-43.4,6-67,19.6c-14,8-27.4,18.2-40,29.8c-1.8,1.8-3.6,3.6-5.4,5.6v8C635.69,504.32,651.89,491.32,668.9,481.32z"
}), React.createElement("path", {
  className: "st0",
  d: "M550.49,790.52c-6-8.2-10.8-18-14.2-29.4l-5.4,3.2c2.6,8.8,6.2,16.8,10.6,24c3.4,1.8,6.8,3.2,10.2,4.4 C551.49,791.92,551.09,791.32,550.49,790.52z"
}), React.createElement("path", {
  className: "st0",
  d: "M531.49,726.72l-5.8,3.4c0.4,7.6,1.2,15,2.4,21.8l5.6-3.2C532.49,741.92,531.49,734.52,531.49,726.72z"
}), React.createElement("path", {
  className: "st0",
  d: "M583.9,564.72c7.6-11.4,16-22.2,24.8-32.4v-7.2c-1.6,2-3.2,4-4.8,6s-3.4,4.2-5,6.2c-5.2,6.6-10.2,13.8-15,21 V564.72z"
}), React.createElement("path", {
  className: "st0",
  d: "M535.09,755.12l-5.4,3.2c0.6,2,1,4.2,1.6,6.2l5.4-3.2C536.09,759.12,535.29,756.92,535.09,755.12z"
}), React.createElement("path", {
  className: "st0",
  d: "M614.89,525.52c2-2.2,4-4,6-6.2v-8l0,0c-2,2.2-4,4.4-6,6.6V525.52z"
}), React.createElement("path", {
  className: "st0",
  d: "M608.69,532.52c2-2.4,4-4.6,6-6.8v-7.4c-1.6,1.8-3,3.4-4.6,5.2c-0.6,0.6-1,1.2-1.6,1.8v7.2H608.69z"
}), React.createElement("path", {
  className: "st0",
  d: "M527.89,751.92c0.4,2.2,1,4,1.6,6.2l5.4-3.2c-0.4-2-1-4-1.4-6.2L527.89,751.92z"
}), React.createElement("path", {
  className: "st0",
  d: "M525.29,716.52l6.2-3.6c1.6-42.2,16.6-88,40.2-128.8v-6.4c-17,28.6-31.4,60.6-40.8,93.4 C527.49,686.52,525.49,701.72,525.29,716.52z"
}), React.createElement("path", {
  className: "st0",
  d: "M531.09,720.12l-5.8,3.4c0,2.4,0.2,4.6,0.2,6.8l5.8-3.4C531.29,724.52,531.09,722.72,531.09,720.12 C531.09,720.32,531.09,720.32,531.09,720.12z"
}), React.createElement("path", {
  className: "st0",
  d: "M583.9,564.72v-6.2c-2,3-4,6.2-6,9.4v6.2C579.89,570.92,581.69,567.92,583.9,564.72z"
}), React.createElement("path", {
  className: "st0",
  d: "M571.49,584.12c2-3.4,4-6.6,6-9.8v-6.2c-2,3.2-4,6.4-6,9.8V584.12z"
}), React.createElement("path", {
  className: "st0",
  d: "M525.29,716.52c0,1.2-0.2,2.6-0.2,4c0,1,0.2,2,0.2,3.2l5.8-3.4c0-2.4,0.2-4.8,0.4-7.2L525.29,716.52z"
}), React.createElement("path", {
  className: "st0",
  d: "M768.49,465.72c-6.2-3.4-12.8-6-19.8-7.4l9.2,5.2C761.49,464.32,765.09,464.72,768.49,465.72z"
}), React.createElement("path", {
  className: "st0",
  d: "M750.49,462.72c-1.8-1.8-3.6-3.6-5.6-5.2c-3.8-0.6-7.8-1-11.8-1.2c3.2,2,6.2,4.2,8.8,6.6 C745.09,463.12,747.7,462.72,750.49,462.72z"
}), React.createElement("path", {
  className: "st0",
  d: "M552.89,794.72c-0.4-0.6-0.8-1.4-1-2c-3.4-1.2-6.8-2.6-10.2-4.4l0,0L552.89,794.72z"
}), React.createElement("path", {
  className: "st0",
  d: "M748.69,458.32c-1.2-0.2-2.4-0.4-3.6-0.6c2,1.6,3.8,3.4,5.6,5.2c2.4,0.2,4.8,0.6,7.2,0.8L748.69,458.32z"
}), React.createElement("path", {
  className: "st0",
  d: "M672.29,486.52c7.2-4.2,14.2-7.6,21.2-10.2c15-7.2,29.6-11.6,43.6-13c1,0,1.8,0,2.8,0 c-20.6-2.4-44.8,3.2-70.6,18.2c-17,9.8-33.2,23-48.4,38.2v8.6C636.49,511.32,653.9,496.92,672.29,486.52z"
}), React.createElement("path", {
  className: "st0",
  d: "M540.49,758.92l-4.2,2.4c3.4,11.4,8,21.2,14.2,29.4c-0.4-0.8-0.8-1.6-1.2-2.4 C545.29,779.12,542.49,769.32,540.49,758.92z"
}), React.createElement("path", {
  className: "st0",
  d: "M537.29,723.32l-6,3.4c0.2,7.8,1,15,2.2,22l5.2-3c-0.2-1.2,0-2.6-0.2-4 C537.89,735.92,537.49,729.92,537.29,723.32z"
}), React.createElement("path", {
  className: "st0",
  d: "M583.9,575.72c7.6-12,15.8-23.6,24.8-34.2v-9c-8.8,10.2-17.2,21-24.8,32.4V575.72z"
}), React.createElement("path", {
  className: "st0",
  d: "M620.69,527.92v-8.4c-2,2-4,4-6,6.2v9C616.49,532.52,618.69,530.32,620.69,527.92z"
}), React.createElement("path", {
  className: "st0",
  d: "M539.89,752.12l-4.8,2.8c0.4,2,1,4.2,1.6,6.2l4.2-2.4C540.29,756.72,540.09,754.32,539.89,752.12z"
}), React.createElement("path", {
  className: "st0",
  d: "M608.69,541.72c2-2.4,4-4.6,6-6.8v-9.2c-2,2.2-4,4.6-6,6.8V541.72z"
}), React.createElement("path", {
  className: "st0",
  d: "M538.9,745.72l-5.2,3c0.4,2.2,0.8,4.2,1.4,6.2l4.8-2.8C539.29,750.12,538.9,747.92,538.9,745.72z"
}), React.createElement("path", {
  className: "st0",
  d: "M537.7,709.12c2.2-36.8,14.6-76.4,34-112.6v-12.6c-23.6,41-38.6,86.8-40.2,128.8L537.7,709.12z"
}), React.createElement("path", {
  className: "st0",
  d: "M537.29,720.52c0-1.2,0.2-2.6,0.2-3.8l-6.2,3.6v0.2c0,2.2,0.2,4.4,0.2,6.6l6-3.4 C537.29,722.52,537.29,721.52,537.29,720.52z"
}), React.createElement("path", {
  className: "st0",
  d: "M577.7,585.52c2-3.4,4-6.6,6-9.8v-11c-2,3-4,6.2-6,9.4V585.52z"
}), React.createElement("path", {
  className: "st0",
  d: "M531.49,712.92c0,2.4-0.4,4.8-0.4,7.2l6.2-3.6c0-2.4,0.2-4.8,0.4-7.2L531.49,712.92z"
}), React.createElement("path", {
  className: "st0",
  d: "M577.7,585.52v-11.4c-2,3.2-4.2,6.6-6,9.8v12.6C573.69,592.92,575.49,589.12,577.7,585.52z"
}), React.createElement("path", {
  className: "st0",
  d: "M548.09,838.72c-1.4-1.4-2.8-3-4-4.6C545.49,835.52,546.89,836.92,548.09,838.72z"
}), React.createElement("path", {
  className: "st0",
  d: "M631.89,500.12c9-8.6,18.4-17,28.4-24.6C650.69,482.72,641.49,490.72,631.89,500.12z"
}), React.createElement("path", {
  className: "st0",
  d: "M540.09,827.92c-0.8-1-1.6-2.2-2.2-3.2C538.49,825.72,539.09,826.72,540.09,827.92z"
}), React.createElement("path", {
  className: "st0",
  d: "M558.69,847.92c-2.4-1.8-4.8-4-7-6C553.9,844.12,556.29,845.92,558.69,847.92z"
}), React.createElement("path", {
  className: "st0",
  d: "M522.7,784.12c-0.4-2.2-0.6-4.4-1-6.6C521.89,779.32,522.29,781.72,522.7,784.12z"
}), React.createElement("path", {
  className: "st0",
  d: "M787.29,438.92c3.4,1.2,6.8,2.6,10.2,4.2C794.09,441.52,790.69,440.12,787.29,438.92z"
}), React.createElement("path", {
  className: "st0",
  d: "M531.89,813.92c-0.4-1-0.8-2-1.2-3C531.09,811.72,531.49,812.92,531.89,813.92z"
}), React.createElement("path", {
  className: "st0",
  d: "M775.09,435.92c4.2,0.8,8.2,1.6,12.2,3C783.09,437.72,779.09,436.92,775.09,435.92z"
}), React.createElement("path", {
  className: "st0",
  d: "M526.89,800.92c-0.4-1.2-0.8-2.4-1.2-3.6C526.29,798.72,526.49,799.92,526.89,800.92z"
}), React.createElement("path", {
  className: "st0",
  d: "M760.29,434.72c-3,0-6,0.2-9.2,0.4c3.6-0.2,7.2-0.4,10.8-0.4C761.49,434.72,760.69,434.72,760.29,434.72z"
}), React.createElement("path", {
  className: "st0",
  d: "M627.89,503.92c-0.8,0.8-1.8,1.8-2.6,2.6c0.2-0.2,0.4-0.4,0.6-0.6C626.69,505.12,627.49,504.52,627.89,503.92z "
}), React.createElement("path", {
  className: "st0",
  d: "M741.49,436.32c1.6-0.2,3-0.4,4.6-0.6C744.49,435.92,742.89,436.32,741.49,436.32z"
}), React.createElement("path", {
  className: "st0",
  d: "M665.49,471.52c2.6-1.8,5-3.6,7.6-5.4C670.49,467.72,667.89,469.52,665.49,471.52z"
}), React.createElement("path", {
  className: "st0",
  d: "M763.9,435.12c3.8,0.2,7.4,0.4,11.2,1.2C771.49,435.32,767.7,435.12,763.9,435.12z"
}), React.createElement("path", {
  className: "st0",
  d: "M526.09,690.52c0.4-2,1-4.2,1.4-6.2C526.69,686.32,526.49,688.12,526.09,690.52z"
}), React.createElement("path", {
  className: "st0",
  d: "M522.49,708.12c0-0.2,0-0.4,0.2-0.8C522.7,707.92,522.7,707.92,522.49,708.12z"
}), React.createElement("path", {
  className: "st0",
  d: "M531.29,669.92c-0.4,1.4-0.8,2.8-1,4.2c0.2-1,0.6-2,0.8-3C531.09,670.52,531.09,670.32,531.29,669.92z"
}), React.createElement("path", {
  className: "st0",
  d: "M620.69,511.32L620.69,511.32c1.8-1.8,3.6-3.6,5.4-5.6c-0.2,0.2-0.4,0.4-0.6,0.6 C623.9,508.32,622.29,509.92,620.69,511.32z"
}), React.createElement("path", {
  className: "st0",
  d: "M608.69,525.32L608.69,525.32c-1.6,1.8-3.2,4-4.8,6C605.29,529.12,606.89,527.12,608.69,525.32z"
}), React.createElement("path", {
  className: "st0",
  d: "M598.9,537.52c-5.2,6.8-10.2,13.6-15,20.8v0.2C588.69,551.32,593.69,544.12,598.9,537.52z"
}), React.createElement("path", {
  className: "st0",
  d: "M620.69,511.32l-0.2,0.2L620.69,511.32z"
}), React.createElement("path", {
  className: "st0",
  d: "M610.29,523.32c-0.4,0.6-1,1.2-1.6,1.8v0.2C609.09,524.52,609.69,524.12,610.29,523.32z"
}), React.createElement("path", {
  className: "st0",
  d: "M571.49,577.72L571.49,577.72c-1,1.6-2.2,3.2-3.2,5c-16.6,28.6-29,58.2-37.4,87.2c0,0.4-0.2,0.8-0.2,1.2 C540.29,638.12,554.89,606.32,571.49,577.72z"
}), React.createElement("path", {
  className: "st0",
  d: "M577.7,567.92c2-3.2,4-6.2,6-9.4v-0.2c-2,3-4,6.2-6,9.2V567.92z"
}), React.createElement("path", {
  className: "st0",
  d: "M571.49,577.72c2-3.4,4-6.6,6-9.8v-0.2C575.49,570.72,573.69,574.12,571.49,577.72L571.49,577.72z"
}), React.createElement("path", {
  className: "st0",
  d: "M532.7,790.12c1.6-2.8,5.4-4,8.2-2.2c0.2,0.2,0.6,0.2,0.8,0.4l-3.2-1.8c-2.8-1.6-6.6-0.6-8.2,2.2 c-1.6,3-0.6,6.6,2.2,8.2l2.2,1.4C531.69,796.52,531.09,792.92,532.7,790.12z"
}), React.createElement("path", {
  className: "st0",
  d: "M551.09,800.72l-13.2-7.6c0.2,0,0.2,0.2,0.4,0.2l-2.8-1.8l2.8,1.6c3.4,2,7,3.6,10.6,4.8c-2.6-3-5-6.4-7-9.8 l0,0c-0.2-0.2-0.6-0.2-0.8-0.4c-2.8-1.6-6.6-0.6-8.2,2.2c-1.6,2.8-0.6,6.4,2,8.2l47.6,27.6c-5.4-3.2-10.2-7-14.6-11.4 C561.49,810.52,556.09,805.92,551.09,800.72z"
}), React.createElement("path", {
  className: "st0",
  d: "M538.09,793.12c-0.2,0-0.2-0.2-0.4-0.2l13.2,7.6l0,0L538.09,793.12z"
}), React.createElement("path", {
  className: "st0",
  d: "M548.9,797.92c-3.6-1.4-7.2-3-10.6-4.8l12.8,7.4C550.29,799.92,549.29,799.12,548.9,797.92z"
}), React.createElement("path", {
  className: "st0",
  d: "M552.89,794.72l-11.2-6.4c2.2,3.6,4.6,6.8,7,9.8c2.4,0.8,4.8,1.4,7,2 C554.89,798.32,553.9,796.72,552.89,794.72z"
}), React.createElement("path", {
  className: "st0",
  d: "M560.29,805.92l-9.2-5.2c4.8,5.2,10.4,9.8,16.4,13.4C565.09,811.72,562.49,809.12,560.29,805.92z"
}), React.createElement("polygon", {
  className: "st0",
  points: "560.29,805.92 551.09,800.52 551.09,800.72  "
}), React.createElement("path", {
  className: "st0",
  d: "M551.09,800.52l9.2,5.4c-1.4-2-3-3.8-4.4-5.8c-2.4-0.6-4.8-1.2-7-2C549.29,799.12,550.29,799.92,551.09,800.52 z"
}), React.createElement("polygon", {
  className: "st0",
  points: "535.29,791.72 538.09,793.12 538.09,793.12  "
}), React.createElement("polygon", {
  className: "st0",
  points: "551.09,800.52 538.09,793.12 538.09,793.12  "
}), React.createElement("polygon", {
  className: "st0",
  points: "551.09,800.52 551.09,800.52 560.29,805.92 560.29,805.92  "
}), React.createElement("path", {
  className: "st1",
  d: "M807.29,441.32c0,0.2-0.2,0.2-0.2,0.2c29.6,18.4,47.8,56,47.8,109c0,54.4-19,114.8-50,168.4 c-30.8,53.6-73.6,100.2-120.8,127.4c-46,26.6-87.6,29.6-118.4,13.2v0.2c-1.2,1.8-3,2.8-5,2.8c-0.8,0-1.6-0.4-2.4-0.6 c0.8,0.4,1.4,1.2,2.2,1.6c14.2,8.2,30.2,12.2,47.4,12.2c24.4,0,51.4-8,79.2-24.2c46.6-26.8,90.2-73,123-129.6 c32.8-56.8,50.8-117.6,50.8-171.4c0-55-18.8-96-53-115.8c-0.8-0.6-1.8-1-2.8-1.4C807.7,435.12,808.69,438.72,807.29,441.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M806.09,639.12c0.2-0.8,0.4-1.6,0.8-2.4c-1,3.4-2.2,6.8-3.4,10.2C804.09,644.12,805.29,641.72,806.09,639.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M811.09,621.52c-0.8,3.6-1.8,7.2-2.8,11C808.9,628.92,810.09,625.12,811.09,621.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M814.09,605.92c-0.4,1.8-0.6,3.4-1,5.2C813.49,609.32,813.9,607.92,814.09,605.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M816.09,594.12c-0.2,1-0.2,1.8-0.4,2.8C815.69,595.72,815.69,594.72,816.09,594.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M817.7,570.72c0,3-0.2,5.8-0.4,8.8C817.49,576.72,817.7,573.92,817.7,570.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M807.7,515.52c6.4,14.4,9.8,31.6,10,51.6c0-22.2-4.2-43.4-14.2-60c0.2,0.6,0.4,1.2,0.8,1.8 C805.29,510.92,806.49,513.12,807.7,515.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M669.69,811.52c22.8-10.8,44.2-27.6,63.2-47.8c-16.4,17.4-34,31.4-51.8,41.8 C677.29,807.72,673.49,809.52,669.69,811.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M748.09,746.32c-0.6,0.8-1.4,1.8-2,2.6C746.69,747.92,747.49,746.92,748.09,746.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M623.09,823.72c1.6,0,3.4-0.2,5.2-0.2c-1.4,0.2-3,0-4.4,0.2C623.69,823.72,623.49,823.72,623.09,823.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M641.49,821.52c-3.6,0.8-7.2,1.4-10.6,1.8C634.29,822.92,637.89,822.12,641.49,821.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M649.69,819.12c0.8-0.2,1.6-0.6,2.4-0.8c-2.6,0.8-5.4,1.6-8,2.4C646.09,820.32,647.7,819.92,649.69,819.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M742.7,752.92c-3,3.6-6.2,7.2-9.4,10.4C736.49,759.92,739.69,756.52,742.7,752.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M666.49,812.92c-2.6,1.2-5.2,2.2-7.6,3.2C661.29,815.12,663.9,814.12,666.49,812.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M671.29,817.52c-0.8,0.4-1.4,0.6-2.2,1C669.89,817.92,670.49,817.72,671.29,817.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M751.09,752.12c-1.4,1.8-3,3.6-4.6,5.2C747.89,755.52,749.69,754.12,751.09,752.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M737.49,767.72c0.2-0.2,0.4-0.4,0.6-0.6c-0.4,0.6-1,1-1.4,1.6C736.69,768.12,737.29,767.92,737.49,767.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M782.7,706.52c10.6-18.4,19.4-37.8,26.2-57.4c-11.8,33.8-31.4,70.2-56.6,101.4 C763.69,736.72,773.9,721.92,782.7,706.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M816.49,623.92c4.6-18.6,7.2-37.2,7.2-55.2c0-6.6-0.4-12.6-1-18.6C825.29,574.52,821.89,600.92,816.49,623.92z "
}), React.createElement("path", {
  className: "st1",
  d: "M660.09,821.92c-2,0.8-4,1.4-6,2.2C656.09,823.72,657.89,822.92,660.09,821.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M813.09,636.52c0.2-0.8,0.4-1.4,0.6-2.2c-0.4,1.4-0.8,2.6-1.2,4C812.7,637.72,812.89,636.92,813.09,636.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M789.09,482.52c1.2,0.8,2.4,1.8,3.6,2.6C791.49,484.32,790.29,483.32,789.09,482.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M820.69,537.72c0,0.4,0.2,0.8,0.2,1.4C821.09,538.32,821.09,537.92,820.69,537.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M597.7,825.92c-1.2-0.4-2.6-0.8-3.8-1.2C595.29,825.32,596.49,825.52,597.7,825.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M607.7,828.32c-1.2-0.2-2.2-0.4-3.4-0.8C605.29,827.92,606.49,828.12,607.7,828.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M630.49,829.32c0.4,0,0.6-0.2,1-0.2c-0.6,0-1.4,0.2-2,0.2C629.89,829.32,630.29,829.32,630.49,829.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M618.49,829.52c-0.2,0-0.2,0-0.4,0C618.09,829.52,618.09,829.52,618.49,829.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M803.49,506.92c10,16.6,14.2,37.8,14.2,60c0,0.6,0,1,0,1.6c0,0.8,0,1.6,0,2.2c0,3-0.2,5.8-0.4,8.8 c-0.2,4.6-0.8,9.4-1.4,14.2c-0.2,1-0.2,1.8-0.4,2.8c-0.4,3-1,6.2-1.4,9.2c-0.4,1.8-0.6,3.4-1,5.2c-0.6,3.4-1.4,6.8-2.2,10.2 c-0.8,3.8-1.8,7.4-2.8,11c-0.2,0.8-0.4,1.6-0.6,2.4c-0.2,0.6-0.4,1.2-0.6,1.8c-0.2,0.8-0.4,1.6-0.8,2.4c-0.8,2.6-1.8,5.2-2.6,7.8 c-6.6,19.2-15.2,38-25.8,56.4c-8.8,15.4-18.8,29.6-29.4,42.8c-0.6,0.8-1.4,1.8-2,2.6c-1.2,1.4-2.4,2.8-3.6,4.2 c-3,3.6-6.2,7-9.4,10.4c0,0,0,0-0.2,0.2l-0.2,0.2c-19,20.2-40.4,37-63.2,47.8c-1,0.6-2.2,1-3.2,1.6c-2.6,1.2-5,2.2-7.6,3.2 c-2.2,0.8-4.4,1.6-6.6,2.4c-0.8,0.2-1.6,0.6-2.4,0.8c-1.8,0.6-3.8,1-5.6,1.4c-0.8,0.2-1.6,0.4-2.4,0.6c-3.6,0.8-7.2,1.4-10.6,1.8 c-0.4,0-0.6,0.2-1,0.2c-0.6,0-1,0-1.6,0c-2,0.2-3.8,0.4-5.4,0.4c-5.4,0.8-10.6,1.4-15.6,1.4c-5.6,0-11-0.6-16.2-1.8 c1,0.4,2,1,3,1.4c1.2,0.4,2.4,0.8,3.8,1.2c2,0.6,4.2,1.4,6.4,1.8c1.2,0.2,2.2,0.6,3.4,0.8c3.4,0.6,6.8,1,10.4,1.2 c0.2,0,0.2,0,0.4,0c3.6,0.2,7.4,0,11.2-0.4c0.6,0,1.4-0.2,2-0.2c7.2-0.8,14.6-2.4,22.4-5c2-0.6,4-1.4,6-2.2c3-1.2,6-2.2,9-3.6 c0.8-0.4,1.4-0.6,2.2-1c4.2-2,8.4-4.2,12.8-6.6c18.6-10.8,36.2-25.2,52.6-42.2c0.4-0.6,1-1,1.4-1.6c3-3,5.8-6.4,8.6-9.6 c1.6-1.8,3-3.4,4.6-5.2c0.4-0.6,1-1.2,1.4-1.8c25.2-31.2,44.8-67.6,56.6-101.4c1.2-3.6,2.4-7,3.6-10.6c0.4-1.4,0.8-2.6,1.2-4 c1-3.4,1.8-7,2.8-10.4c5.4-22.6,8.6-49,6.2-73.8c-0.4-3.8-0.8-7.6-1.6-11c0-0.4-0.2-0.8-0.2-1.4c-1.8-9-4.4-17.2-7.6-24.6 c-5.2-11.4-12.2-20.8-20.6-27.8c-1.2-1-2.4-1.8-3.6-2.6c-0.2-0.2-0.4-0.2-0.6-0.4C794.49,488.92,799.69,497.72,803.49,506.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M562.89,795.52c1.6,0.2,3.2,0.4,4.8,0.6c-2.8-4-5.4-8.2-7.4-12.8c-4.2-9.2-6.8-19.6-8.4-31l-5.6,3.2 c1.8,11.2,4.6,21.4,8.6,30.2c0.2,0.6,0.6,1.2,1,1.8C557.89,790.52,560.29,792.92,562.89,795.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M683.9,487.72c-19,11-37,25.8-53.4,43c-3.4,3.6-6.6,7.4-9.8,11v9.4c4.6-5.6,9.4-11.2,14.2-16.2 c16.6-17.4,34.2-31.6,52.2-42c17.8-10.2,35-16.2,51-17.8c2.8-0.4,5.6-0.4,8.4-0.4c2.2,0,4.4,0.2,6.6,0.4c-1-1.4-2-2.8-3.2-4 c-3-0.8-6.2-1.6-9.4-2c-1,0-2,0-3,0C721.09,470.72,702.89,476.92,683.9,487.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M551.09,715.52l-6.2,3.6c-0.2,3.6-0.4,7.2-0.4,10.8c0,4.2,0.2,8.4,0.6,12.4l6-3.4c-0.2-3-0.4-5.8-0.4-9 C550.29,725.32,550.49,720.52,551.09,715.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M590.29,595.32c5.6-9.8,11.8-19.2,18.2-28v-10.2c-8.4,11.2-16.4,23-23.4,35.2c-0.4,0.8-1,1.8-1.4,2.6v12.8 C586.09,603.32,587.89,599.32,590.29,595.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M545.29,749.12c0.2,2.2,0.6,4.4,1,6.4l5.6-3.2c-0.2-2.2-0.6-4.2-0.8-6.4L545.29,749.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M614.89,559.12c2-2.6,4-5.2,6-7.6v-9.4c-2,2.4-4,4.8-6,7.2V559.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M550.69,739.12l-6,3.4c0.2,2.2,0.4,4.4,0.6,6.6l5.6-3.2C550.69,743.72,550.69,741.32,550.69,739.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M614.89,559.12v-9.8c-2,2.6-4,5.2-6,7.8v10.2C610.49,564.32,612.7,561.72,614.89,559.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M546.09,704.32l6.6-3.8c1.8-12,4.4-24.2,8-36.8c3-10.2,6.8-20.4,11-30.6v-14.8c-6.6,14.4-12.4,29-16.8,43.8 C550.49,676.52,547.7,690.52,546.09,704.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M551.49,708.12l-6.6,3.8c-0.2,2.4-0.2,4.8-0.4,7.2l6.2-3.6C551.09,713.12,551.49,710.52,551.49,708.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M583.9,607.72v-12.8c-2,3.6-4,7.4-6,11.2v13.8C579.69,615.52,581.49,611.72,583.9,607.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M571.49,633.12c1.8-4.6,4-9,6-13.6v-13.8c-2.2,4.2-4.2,8.2-6,12.4V633.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M546.09,704.32c-0.4,2.6-0.6,5-1,7.6l6.6-3.8c0.2-2.4,0.6-5,0.8-7.6L546.09,704.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M567.7,795.92c-1.6-0.2-3.2-0.2-4.8-0.6c2.8,2.6,5.6,5,8.8,7c0.4,0,0.6,0,1,0 C571.09,800.52,569.29,798.12,567.7,795.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M760.29,475.12c-3.4-1.6-6.8-3-10.4-4c1,1.4,2.2,2.6,3.2,4c2.6,0.2,5.4,0.6,7.8,1.2 C760.49,475.92,760.29,475.72,760.29,475.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M763.69,476.92c-1.2-0.6-2.2-1.2-3.4-1.6c0.2,0.4,0.4,0.8,0.6,1.2C761.69,476.52,762.7,476.52,763.69,476.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M575.09,804.52c-0.8-0.8-1.6-1.4-2.2-2.2c-0.4,0-0.6,0-1,0c1,0.6,1.8,1.4,2.8,2 C574.49,804.52,574.89,804.52,575.09,804.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M617.7,823.72c-3-0.2-6-0.6-9-1C611.49,822.92,614.49,823.32,617.7,823.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M620.29,823.72c1,0,1.8,0,2.8,0c0.2,0,0.6-0.2,0.8-0.2C622.7,823.72,621.49,823.72,620.29,823.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M788.9,489.52c6,5.2,11.2,11.6,15.4,19.2c-0.2-0.6-0.4-1.2-0.8-1.8C799.69,500.32,794.49,494.52,788.9,489.52z "
}), React.createElement("path", {
  className: "st1",
  d: "M592.7,817.52c1.2,0.6,2.2,1,3.4,1.6c-1-0.4-2.2-1-3.2-1.4C592.7,817.52,592.7,817.52,592.7,817.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M786.29,487.72c-0.8-0.6-1.4-1.2-2.2-1.6l0.2,0.2C784.89,486.92,785.49,487.52,786.29,487.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M605.29,821.72c-1.8-0.4-3.8-1-5.6-1.6C601.49,820.72,603.49,821.52,605.29,821.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M782.7,478.12c-0.2-0.2-0.4-0.2-0.6-0.4l1.2,1C783.09,478.32,782.89,478.32,782.7,478.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M783.9,486.32c0.8,0.6,1.6,1.2,2.2,1.6c0.8,0.6,1.6,1.2,2.4,1.8c6,5,10.8,10.8,14.8,17.4 c-3.8-9.4-8.8-18-15-25c-1.6-1.2-3.2-2.4-5-3.6l-1.4-0.8c-4.8-2.8-10-4.6-15.6-6.2C773.09,475.32,778.9,480.12,783.9,486.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M617.7,823.72c-3-0.2-6-0.4-9-1c-1.2-0.2-2.2-0.6-3.4-0.8c-1.8-0.4-3.8-1-5.6-1.6c-1.2-0.4-2.4-0.8-3.6-1.2 s-2.2-1-3.4-1.6c-1-0.2-1.8-0.4-2.8-0.6c1.4,1.8,1.6,4.2,0.6,6.2c0.2,0,0.4,0.2,0.6,0.2c5.2,1,10.6,1.8,16.2,1.8 c5,0,10.4-0.4,15.6-1.4c-1,0-1.8,0-2.8,0C619.29,823.72,618.69,823.72,617.7,823.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M555.69,787.52c1.2,2.6,2.6,5.2,4,7.6c1,0.2,2,0.4,3.2,0.6C560.29,792.92,557.89,790.52,555.69,787.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M747.89,468.92c-2.4,0-5,0-7.6,0.2c3.2,0.4,6.4,1.2,9.4,2C749.09,470.32,748.69,469.52,747.89,468.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M783.9,486.32c-0.8-0.4-1.4-1-2-1.6l-2-1c1.4,0.8,2.8,1.8,4.2,2.8L783.9,486.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M767.89,476.52c0.4,0.6,0.6,1.4,1,2c3.6,1.2,7.2,2.8,10.4,4.6L767.89,476.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M585.69,813.92L585.69,813.92l2,1.2c-3.2-1.8-6.2-4-8.8-6.4c-0.6,0-1.4,0.2-2,0.2L585.69,813.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M588.49,815.52L588.49,815.52c1.4,0.8,2.8,1.4,4.2,2h0.2C591.49,816.72,589.89,816.32,588.49,815.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M565.29,801.72c2.2,0.2,4.4,0.6,6.6,0.6c-3.2-2-6-4.4-8.8-7c-1-0.2-2-0.4-3.2-0.6c1.4,2.2,2.8,4.4,4.4,6.4 L565.29,801.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M760.29,475.12c-1.2-2-2.6-3.8-3.8-5.6c-2.8-0.4-5.4-0.6-8.4-0.6c0.6,0.8,1.2,1.4,1.8,2.2 C753.49,472.12,756.69,473.72,760.29,475.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M760.29,475.12c1.2,0.6,2.4,1,3.4,1.6c1.8,0.4,3.6,1,5.4,1.6c-0.4-0.6-0.6-1.4-1-2l11.4,6.6 c0.2,0,0.2,0.2,0.4,0.2s0.2,0.2,0.2,0.2l1.8,1c0.8,0.4,1.4,1,2,1.6c-5-5.8-10.8-10.8-17.4-14.6c-3.4-1-6.8-1.6-10.4-2 C757.7,471.32,758.9,473.32,760.29,475.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M578.9,808.32c-1.4-1.2-2.6-2.6-4-3.8c-0.2,0-0.4-0.2-0.4-0.2c-1-0.6-1.8-1.4-2.8-2c-2.2,0-4.4-0.4-6.6-0.6 l11.8,6.8C577.7,808.72,578.09,808.72,578.9,808.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M590.09,816.72c1,0.2,1.8,0.4,2.8,0.6c-1.4-0.6-2.8-1.4-4.2-2C588.9,815.72,589.69,816.32,590.09,816.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M664.49,457.12c-1.4,1-2.8,2-4.2,3C661.69,459.32,663.09,458.32,664.49,457.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M651.29,466.92c-3.2,2.6-6.6,5.2-9.8,8C644.49,472.52,647.89,469.52,651.29,466.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M750.49,423.12c-1.8,0.2-3.6,0.4-5.4,0.6C746.89,423.32,748.9,423.32,750.49,423.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M680.49,447.12c0.4-0.2,0.8-0.4,1-0.6c-0.2,0.2-0.4,0.2-0.6,0.4C680.69,446.92,680.49,446.92,680.49,447.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M510.69,786.72c-0.6-2.6-0.8-5.2-1.2-7.8c0.4,3.2,1,6.4,1.6,9.4C511.09,787.92,510.69,787.52,510.69,786.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M514.29,800.92c0.6,1.8,1.2,3.6,1.8,5.4C515.29,804.52,514.89,802.92,514.29,800.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M519.89,816.32c0.6,1.2,1,2.6,1.6,4C520.69,818.92,520.29,817.52,519.89,816.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M634.09,481.32c-2.4,2-4.6,4.2-7,6.4C629.69,485.32,631.89,483.32,634.09,481.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M752.7,423.12c3.4-0.2,6.6-0.2,10-0.2h-0.2C759.09,422.72,755.69,422.72,752.7,423.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M588.69,530.72c-1.6,2.2-3.2,4.2-4.8,6.4v0.2C585.29,535.32,586.89,532.92,588.69,530.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M595.49,521.92c1.6-2,3.2-4,4.8-5.8C598.9,517.92,597.29,520.12,595.49,521.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M507.29,747.92L507.29,747.92c0-0.2,0-0.4,0-0.8C507.29,747.52,507.29,747.72,507.29,747.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M616.49,498.32c-0.6,0.6-1.2,1.2-1.8,1.8v0.2C615.29,499.52,616.09,498.92,616.49,498.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M507.89,768.12c0-0.8,0-1.8-0.2-2.6C507.89,766.52,507.89,767.52,507.89,768.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M614.89,500.12c-0.8,0.8-1.6,1.8-2.4,2.8C612.89,501.92,613.9,501.32,614.89,500.12L614.89,500.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M516.89,675.72c11.4-43.2,31.4-85.4,54.6-120.8v-0.4c-4.8,7.2-9.2,14.4-13.6,22 C539.29,609.12,525.49,642.92,516.89,675.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M508.09,726.52L508.09,726.52c0-0.4,0-0.6,0.2-1C508.09,725.52,508.09,725.92,508.09,726.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M513.49,691.32c1-4.2,1.8-8.4,2.8-12.8C515.29,682.92,514.09,686.92,513.49,691.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M510.09,709.12c0.4-2.4,0.8-4.8,1.2-7.2C511.09,704.32,510.49,706.72,510.09,709.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M583.9,537.52L583.9,537.52c-1,1.2-2,2.6-2.8,4C581.69,540.12,582.7,538.92,583.9,537.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M580.49,541.72c-1,1.4-1.8,2.6-2.8,4v0.2C578.69,544.52,579.69,543.12,580.49,541.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M507.89,728.12c0-0.6,0.2-1.4,0.2-2l0,0C507.89,726.92,507.89,727.72,507.89,728.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M571.49,555.12c2-3,4-6,6-9v-0.2c-2,3-4.2,5.8-6,8.8V555.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M516.89,787.12c1,4.4,2,8.8,3.4,13C519.09,795.92,517.89,791.72,516.89,787.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M801.69,438.32c-0.4-0.2-1-0.4-1.4-0.6c1.4,0.8,3,1.4,4.4,2.2c0.8,0.4,1.4,1,2.2,1.6c0-0.2,0.2-0.2,0.2-0.2 c1.6-2.8,0.6-6.2-2.2-8c-8.8-4.6-18.2-7.8-28.4-9.4L801.69,438.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M565.49,859.92L565.49,859.92c-0.8-0.6-1.6-1-2.4-1.4c-2.4-1.4-4.4-3-6.6-4.6c1.2,1,2.4,2,3.8,2.8 c-5.2-3-14.8-8.4-24.6-13.8c6.4,7.6,13.8,14.2,22.2,19.4c0.8,0.4,1.6,0.6,2.4,0.6C562.49,862.92,564.29,861.72,565.49,859.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M516.09,780.52c-0.4-2.2-0.6-4.6-1-6.8l0,0C515.29,775.72,515.49,778.12,516.09,780.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M543.9,842.92C543.9,842.92,543.9,842.72,543.9,842.92C543.9,842.72,543.9,842.92,543.9,842.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M535.29,831.92c1.4,2,2.8,3.8,4.2,5.6C538.09,835.72,536.69,834.12,535.29,831.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M521.49,803.72c2.8,8.8,6.6,17,11.4,24.6C528.49,820.72,524.29,812.72,521.49,803.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M774.09,429.92c0.6,0,1.4,0.2,2,0.4C775.49,430.12,774.89,429.92,774.09,429.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M672.7,459.52c3-2,5.8-3.8,8.8-5.6C678.49,455.72,675.49,457.52,672.7,459.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M771.09,429.52c-26-3-52.6,4.6-77.6,17.6C721.69,432.52,748.09,426.92,771.09,429.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M628.69,494.72c-2.8,2.6-5.4,5.2-8,8l0,0C623.49,500.12,626.09,497.52,628.69,494.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M586.09,544.32c-0.8,1-1.6,2.2-2.2,3.2l0,0C584.49,546.72,585.29,545.52,586.09,544.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M591.89,536.52c2.6-3.4,5.4-7,8-10.4C597.49,529.32,594.49,532.92,591.89,536.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M513.69,736.92L513.69,736.92c-0.6,8-0.4,15.6,0,23.2h0.2c-0.2-4-0.6-8-0.6-12.4 C513.09,744.32,513.69,740.52,513.69,736.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M608.69,515.72c-0.8,1-1.6,1.8-2.4,2.8c-0.8,0.8-1.4,1.8-2.2,2.6c1.4-1.8,3-3.4,4.6-5.2V515.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M515.09,773.72L515.09,773.72c-0.2-2-0.6-3.8-0.8-6C514.29,769.52,514.49,771.72,515.09,773.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M620.69,502.72L620.69,502.72c-0.6,0.4-1,1-1.6,1.6C619.69,503.92,620.29,503.32,620.69,502.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M616.29,507.52c-0.6,0.6-1,1-1.6,1.6v0.2C615.29,508.72,615.69,508.12,616.29,507.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M608.69,515.92c2-2.4,4-4.6,6-6.8v-0.2C612.49,511.32,610.29,513.72,608.69,515.92L608.69,515.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M513.9,766.92c-0.2-2.2-0.2-4.4-0.4-6.8h-0.2C513.9,762.72,513.9,764.72,513.9,766.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M526.69,662.92c1.4-4.6,3-9.2,4.6-13.8C529.89,653.72,528.09,658.12,526.69,662.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M521.09,684.52c1.4-6.4,3.2-12.8,5.2-19.2C524.09,671.72,522.49,678.12,521.09,684.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M520.69,685.12c-3,12.6-5.2,25.2-6.4,37.6l0.2-0.2C516.09,710.32,517.89,697.72,520.69,685.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M513.9,730.12L513.9,730.12c-0.4,2.6-0.4,5-0.6,7.4l0.2-0.2C513.9,734.72,513.9,732.52,513.9,730.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M583.9,547.92L583.9,547.92c-0.4,0.4-0.8,1-1,1.6C582.89,548.92,583.49,548.12,583.9,547.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M514.29,722.72c-0.2,2.4-0.6,5-0.6,7.4l0.2-0.2C514.09,727.52,514.29,725.12,514.29,722.72L514.29,722.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M543.9,842.72c-1.4-1.6-2.8-3.2-4.2-5s-3-3.8-4.2-5.6c-0.8-1.2-1.8-2.6-2.6-3.8c-4.8-7.6-8.6-15.8-11.4-24.6 c-0.4-1-0.6-2.2-1-3.4c-1.2-4.2-2.4-8.6-3.4-13c-0.4-2.2-0.8-4.4-1.2-6.8c-0.4-2.2-0.8-4.6-1-6.8l-5.6,3.2c0,0.8,0.2,1.4,0.2,2.2 c0.4,2.6,0.6,5.2,1.2,7.8c0.2,0.6,0.2,1,0.4,1.6c1,4.4,2,8.6,3.2,12.8c0.6,1.8,1.2,3.6,1.8,5.4c1.2,3.4,2.4,6.6,3.6,9.6 c0.6,1.2,1,2.6,1.6,4c4,8.4,8.8,16,14.4,22.8c9.8,5.6,19.4,11,24.6,13.8c-1.4-0.8-2.4-1.8-3.8-2.8 C552.29,850.52,547.7,846.92,543.9,842.72C543.9,842.92,543.9,842.72,543.9,842.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M762.49,422.72c-3.2-0.2-6.6,0-10,0.2c-0.6,0-1.4,0-2,0.2c-1.8,0.2-3.6,0.4-5.4,0.6 c-20,2.6-41.4,10.2-63.4,22.8c-0.4,0.2-0.8,0.4-1,0.6c-5.4,3-10.6,6.4-15.8,10c-1.4,1-2.8,2-4.2,3c-3,2.2-6.2,4.6-9.2,6.8 c-3.4,2.6-6.6,5.2-9.8,8c-2.4,2-4.8,4-7.2,6.2s-4.6,4.2-7,6.4c-2.2,2.2-4.4,4.4-6.6,6.6v8.6c2.6-2.6,5.2-5.2,8-8 c14-13.6,28.6-25.6,44-35.6c2.8-2,5.8-3.8,8.8-5.6c0.8-0.6,1.8-1.2,2.6-1.6c3.2-1.8,6.4-3.6,9.4-5.2c25-13,51.6-20.6,77.6-17.6 c1,0.2,2,0.2,3.2,0.4c0.6,0.2,1.4,0.2,2,0.4c8.6,1.4,16.8,4,24.2,7.8c0.4,0.2,1,0.4,1.4,0.6l-25.2-14.4 C771.89,423.32,767.29,422.72,762.49,422.72L762.49,422.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M513.69,760.52c-0.4-7.6-0.6-15.2-0.2-23l-6,3.4c0,2.2-0.2,4.2-0.2,6.4c0,0.4,0,0.6,0,1 c0,5.4,0.4,10.4,0.6,15.6L513.69,760.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M583.9,547.92c0.8-1,1.6-2.2,2.2-3.2c2-2.8,4-5.4,6-8c2.6-3.6,5.4-7,8-10.4c1.4-1.6,2.6-3.2,4-4.8 c0.8-0.8,1.4-1.8,2.2-2.6s1.6-1.8,2.4-2.8v-9c-2.8,3-5.4,6-8.2,9.2c-1.6,1.8-3.2,4-4.8,5.8c-2.4,3-4.8,6-7,9 c-1.6,2.2-3.2,4.4-4.8,6.6L583.9,547.92L583.9,547.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M513.9,766.92l-5.6,3.2c0.2,2.2,0.6,4.4,1,6.4l5.6-3.2c-0.2-2-0.6-4-0.8-6 C514.09,767.52,514.09,767.12,513.9,766.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M614.89,500.12v8.8c0.6-0.6,1-1,1.6-1.6c1-1,2-2,3-3.2c0.4-0.6,1-1,1.6-1.6v-8.6c-1.4,1.4-2.8,2.6-4.2,4.2 C616.09,498.92,615.29,499.52,614.89,500.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M513.69,760.52l-5.8,3.2c0,0.6,0,1.4,0,2c0,0.8,0,1.8,0.2,2.6c0,0.8,0.2,1.4,0.4,2.2l5.6-3.2c0,0,0,0,0-0.2 C513.9,764.72,513.9,762.72,513.69,760.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M608.69,515.72c2-2.2,4-4.4,6-6.8v-8.8c-0.8,0.8-1.6,1.8-2.4,2.6c-1.2,1.4-2.4,2.6-3.6,4V515.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M516.49,678.72c-1,4.2-2,8.4-2.8,12.8c-0.8,3.6-1.4,7-2,10.6c-0.4,2.4-0.8,4.8-1.2,7.2 c-0.8,5.4-1.4,10.8-2,16.2c0,0.4,0,0.6,0,1l6.4-3.6c1.2-12.4,3.4-25,6.4-37.6c0-0.2,0-0.2,0-0.4c1.6-6.4,3.2-12.8,5.2-19.2 c0.2-1,0.4-1.8,0.8-2.8c1.4-4.6,3-9.2,4.6-13.8c8.2-23.8,19-47.2,31.8-69.4c2.6-4.6,5.6-9.2,8.4-13.8v-11 c-23.2,35.6-43.2,77.6-54.6,120.8C516.69,676.72,516.49,677.72,516.49,678.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M507.89,733.72c-0.2,2.4-0.2,4.8-0.2,7.2l6-3.4c0.2-2.4,0.2-4.8,0.4-7.2L507.89,733.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M577.7,556.52c1.6-2.4,3.2-4.8,5-7.2c0.4-0.6,0.8-1,1-1.6v-10.2c-1,1.4-2,2.6-2.8,3.8 c-0.2,0.2-0.2,0.4-0.4,0.6c-1,1.4-1.8,2.8-2.8,4.2L577.7,556.52L577.7,556.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M514.29,722.72l-6.4,3.6c0,0.6-0.2,1.4-0.2,2c-0.2,1.8-0.2,3.6-0.2,5.2l6-3.4 C513.9,727.72,514.09,725.32,514.29,722.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M577.7,556.52v-10.4c-2,3-4,6-6,9v11C573.69,562.72,575.49,559.52,577.7,556.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M590.09,816.72c-6.6-1.6-12.8-3.8-18.4-7.2c4.2,4.2,8.8,8,13.6,10.8c1.8,1,3.6,1.8,5.4,2.6 C591.49,820.72,591.29,818.72,590.09,816.72z"
}), React.createElement("polygon", {
  className: "st1",
  points: "588.49,815.52 588.49,815.52 588.09,815.32  "
}), React.createElement("path", {
  className: "st1",
  d: "M585.69,813.92l-8.8-5.2h-0.2l11.4,6.6c-0.2,0-0.2-0.2-0.4-0.2L585.69,813.92L585.69,813.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M564.09,801.52c0.2,0.2,0.2,0.2,0.4,0.4c0.2,0,0.4,0,0.6,0L564.09,801.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M588.09,815.32l-11.4-6.6h0.2l-11.8-6.8c-0.2,0-0.4,0-0.6,0c2.2,2.8,4.4,5.4,6.8,7.8 c5.6,3.2,11.8,5.6,18.4,7.2C589.29,816.32,588.9,815.72,588.09,815.32C588.49,815.52,588.09,815.32,588.09,815.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M520.49,770.52c0.2,2.4,0.6,4.6,1,6.8C521.29,775.12,520.69,772.72,520.49,770.52L520.49,770.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M551.49,841.72c-1.2-1-2.2-2.2-3.4-3.2C549.29,839.52,550.29,840.72,551.49,841.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M787.29,438.92L787.29,438.92L787.29,438.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M818.9,638.12c0-0.2,0.2-0.4,0.2-0.8c-0.2,0.4-0.2,0.8-0.4,1.2C818.9,638.72,818.9,638.32,818.9,638.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M775.09,435.92L775.09,435.92L775.09,435.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M537.7,824.72c-2-3.4-4-7-5.8-10.8C533.9,817.72,535.49,821.52,537.7,824.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M544.09,834.12c-1.6-1.8-3-3.8-4.4-6C541.49,830.12,542.7,831.92,544.09,834.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M530.49,810.72c-1.4-3.2-2.6-6.4-3.6-9.8C528.09,804.32,529.29,807.72,530.49,810.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M522.7,784.32c0.8,4.4,2,8.8,3.2,12.8c-1.2-4.4-2.4-8.8-3.2-13.4C522.7,784.12,522.7,784.12,522.7,784.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M761.89,434.72c0.6,0,1.2,0,2,0.2C763.09,435.12,762.7,434.72,761.89,434.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M823.49,522.92c0,0.2,0.2,0.4,0.2,0.6C823.69,523.32,823.49,523.12,823.49,522.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M660.49,475.12c1.6-1.2,3.2-2.4,5-3.6C663.9,472.72,662.29,473.92,660.49,475.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M627.89,503.92c1.4-1.4,2.6-2.6,4-4C630.69,501.32,629.29,502.72,627.89,503.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M799.09,443.92c-0.6-0.4-1.2-0.4-1.8-0.8c1.4,0.8,3,1.2,4.4,2c30.4,17.4,47,55,47,105.4 c0,51.6-17.4,110.4-49.2,165.2c-31.8,55-73.8,99.4-118.4,125.2c-43.6,25.2-84.4,29.4-114.8,12c-2.8-1.6-5.2-3.4-7.6-5.4 c1.6,1.2,3.4,2.6,5.2,3.8c2.6,1.8,3.4,5.2,1.8,8c30.8,16.4,72.4,13.4,118.4-13.2c47.2-27.2,89.8-74,120.8-127.4 c31-53.6,50-113.8,50-168.4c0-53.2-18.2-90.6-47.8-109C805.29,444.52,801.89,445.32,799.09,443.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M793.49,478.12c1,0.8,2,1.4,3,2.2C795.29,479.52,794.29,478.92,793.49,478.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M827.7,596.72c-0.4,3.6-1,7.4-1.6,11C826.69,604.12,827.49,600.52,827.7,596.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M746.09,435.72c1.6-0.2,3.4-0.4,5-0.6C749.29,435.12,747.7,435.72,746.09,435.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M825.09,613.32c-0.6,3.2-1.2,6.2-2,9.4C823.9,619.52,824.29,616.72,825.09,613.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M785.69,472.72c-0.2,0-0.2-0.2-0.4-0.2l0.8,0.4C786.09,473.12,786.09,473.12,785.69,472.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M828.9,550.52c0.2,2.4,0.4,4.8,0.6,7C829.09,555.12,828.9,552.72,828.9,550.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M741.49,436.32c-23.2,4-46.6,14.8-68.4,29.6c4.6-3.2,9.2-6.2,14-8.8 C706.09,446.32,724.09,439.52,741.49,436.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M631.29,835.52c0.2,0,0.2,0,0.4,0C631.49,835.52,631.29,835.52,631.29,835.52 C631.09,835.52,631.09,835.52,631.29,835.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M818.9,510.32L818.9,510.32L818.9,510.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M662.29,827.72c-2.2,0.8-4.2,1.6-6.4,2.2C657.89,829.12,660.29,828.32,662.29,827.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M674.49,822.52c-1.2,0.6-2.2,1-3.4,1.6C672.49,823.32,673.49,822.92,674.49,822.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M715.29,796.32c-0.2,0.2-0.4,0.4-0.6,0.6C715.09,796.72,715.29,796.52,715.29,796.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M686.89,815.72c0.2,0,0.2-0.2,0.4-0.2c-0.2,0.2-0.4,0.2-0.6,0.4C686.69,815.92,686.89,815.92,686.89,815.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M813.9,654.12c-0.4,1-0.6,1.8-1,2.8C813.09,655.72,813.49,655.12,813.9,654.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M827.7,596.52c1.2-9.4,2-18.8,2-27.8c0-1.8-0.2-3.6-0.2-5.4C829.89,574.12,829.09,585.52,827.7,596.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M787.89,709.32c8.6-14.8,15.8-30.2,22-45.6c-14.4,36-36.6,73-64.4,103.6 C761.49,750.32,775.69,730.72,787.89,709.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M729.89,783.72c-1,1-2,1.8-3,2.6C727.7,785.52,728.9,784.52,729.89,783.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M741.69,771.72c0.6-0.6,1.2-1.2,1.6-1.8c-1.8,2-3.8,4-5.8,6C739.09,774.32,740.29,773.12,741.69,771.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M601.09,833.32c-6.2-1.6-12.2-4-17.8-7.2C588.9,829.32,594.89,831.72,601.09,833.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M519.89,733.72l-0.4,0.2c-0.4,7.8-0.4,15.6,0,23.2h0.2c-0.2-3-0.4-5.8-0.4-9 C519.29,743.12,519.69,738.32,519.89,733.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M520.09,763.72L520.09,763.72c0.2,2.2,0.4,4.4,0.6,6.6l0,0C520.29,768.12,520.29,765.92,520.09,763.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M519.69,756.92c0.2,2.2,0.2,4.6,0.4,6.8l0,0C519.89,761.52,519.89,759.12,519.69,756.92L519.69,756.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M522.49,708.12c-0.6,3.6-1,7.2-1.6,10.6l0.2-0.2C521.49,715.32,521.89,711.72,522.49,708.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M527.49,684.12c0.8-3.4,1.8-6.6,2.6-10C528.9,677.52,528.09,680.52,527.49,684.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M522.7,707.72c1-5.6,2-11.4,3.4-17.2C524.49,695.92,523.69,701.72,522.7,707.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M520.29,726.52c-0.2,2.4-0.6,5-0.6,7.4l0.4-0.2C520.09,730.92,520.29,728.92,520.29,726.52L520.29,726.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M521.09,719.12c-0.2,2.4-0.6,5-0.8,7.4h0.2c0.2-2.4,0.6-5,0.8-7.6L521.09,719.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M769.69,466.32c7,4,13.4,9.4,18.8,15.6c0.2,0.2,0.4,0.4,0.6,0.6c1.2,0.8,2.4,1.6,3.6,2.6 c15.6,13,24.2,31.8,28.2,52.4c0,0.4,0.2,0.8,0.2,1.4c0.6,3.6,1.2,7.4,1.6,11c0.6,6,1,12.2,1,18.6c0,17.8-2.6,36.4-7.2,55.2 c-0.8,3.6-1.8,7-2.8,10.4c-0.2,0.8-0.4,1.4-0.6,2.2c-0.2,0.6-0.4,1.2-0.6,1.8c-0.2,0.8-0.6,1.8-0.8,2.6c-0.8,2.6-1.8,5.4-2.8,8 c-6.8,19.6-15.6,39-26.2,57.4c-9,15.6-19.2,30.4-30.4,44c-0.4,0.6-1,1.2-1.4,1.8c-1.4,1.8-3,3.6-4.6,5.2c-2.8,3.2-5.6,6.4-8.6,9.6 c-0.2,0.2-0.4,0.4-0.6,0.6c-0.4,0.4-0.6,0.6-1,1c-19.6,20.6-41.6,37.8-65.2,48.8c-0.8,0.4-1.4,0.6-2.2,1c-3,1.4-6,2.6-9,3.6 c-2,0.8-4,1.4-6,2.2c-0.8,0.2-1.8,0.6-2.6,1c-6.6,2-13.2,3.4-19.8,4c-0.4,0-0.6,0.2-1,0.2c-0.4,0-0.6,0-1,0 c-3.8,0.4-7.4,0.4-11.2,0.4c-0.2,0-0.2,0-0.4,0c-3.4-0.2-7-0.6-10.4-1.2c-1.2-0.2-2.2-0.4-3.4-0.8c-2.2-0.4-4.2-1.2-6.4-1.8 c-1.2-0.4-2.6-0.8-3.8-1.2c-1-0.4-2.2-1-3.2-1.4h-0.2c0,0.2,0,0.2-0.2,0.4c-1.2,1.8-3.2,3-5.2,3c-1,0-2-0.2-3-0.8 c0.4,0.2,0.8,0.4,1.2,0.6c5.6,3,11.6,5.6,17.8,7.2c6.4,1.6,13.4,2.4,20.4,2.4c3,0,6.2-0.2,9.4-0.4c0.2,0,0.4,0,0.6,0 c8-0.8,16.2-2.8,24.4-5.4c2.2-0.6,4.2-1.4,6.4-2.2c3-1.2,6-2.2,9-3.6c1.2-0.4,2.2-1,3.4-1.6c4-2,8.2-4,12.2-6.4 c0.2-0.2,0.4-0.2,0.6-0.4c9.2-5.4,18.4-11.8,27.4-18.8c0.2-0.2,0.4-0.4,0.6-0.6c3.8-3.2,7.6-6.4,11.4-9.8c1-0.8,2-1.8,3-2.6 c2.6-2.6,5.4-5.2,8-7.8c2-2,3.8-4,5.8-6c0.8-0.8,1.4-1.6,2-2.4c27.6-30.6,50-67.8,64.4-103.6c1-2.4,2-4.6,2.8-7 c0.4-1,0.6-1.8,1-2.8c1.8-5,3.6-10.2,5-15.4c0.2-0.4,0.2-0.8,0.4-1.2c1.4-5,2.8-9.8,3.8-14.6c0.8-3.2,1.4-6.2,2-9.4 c0.4-2,0.8-3.8,1.2-5.8c0.6-3.6,1.2-7.2,1.6-11c0-0.2,0-0.2,0-0.4c1.4-11,2-22.2,1.8-33.2c0-2-0.2-4-0.2-5.8 c-0.2-2.4-0.2-4.8-0.6-7c-1-9.6-2.6-18.6-5.2-26.8c0-0.2-0.2-0.4-0.2-0.6c-1.4-4.4-3-8.4-4.6-12.4l0,0c-5.6-12.4-13-22.4-22.2-30.2 c-1-0.8-2-1.4-3-2.2c-2.4-1.8-4.6-3.4-7.2-5l-0.8-0.4c-5.2-3-11-5.2-17-6.8C768.9,465.92,769.09,466.32,769.69,466.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M752.49,750.52c-0.4,0.6-1,1.2-1.4,1.8C751.49,751.72,751.89,750.92,752.49,750.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M671.29,817.52c23.8-11,45.8-28.2,65.2-48.8c-16.2,17-33.8,31.4-52.6,42.2 C679.69,813.12,675.29,815.52,671.29,817.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M816.49,623.92c-0.8,3.4-1.8,7-2.8,10.4C814.89,630.72,815.49,627.52,816.49,623.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M813.09,512.92c3.4,7.4,5.8,15.6,7.6,24.6c-4-20.8-12.6-39.4-28.2-52.4 C801.09,492.12,807.89,501.52,813.09,512.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M746.49,757.52c-2.8,3.2-5.6,6.6-8.6,9.6C741.09,763.92,743.9,760.52,746.49,757.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M821.29,538.92c0.6,3.6,1.2,7.2,1.6,11C822.29,546.32,821.69,542.72,821.29,538.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M811.69,640.72c0.2-0.8,0.6-1.8,0.8-2.6c-1,3.6-2.2,7.2-3.6,10.6C810.09,646.32,811.09,643.72,811.69,640.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M604.09,827.92c-2.2-0.6-4.4-1.2-6.4-1.8C600.09,826.72,601.89,827.12,604.09,827.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M590.69,823.12c1,0.4,2.2,1,3.2,1.4C592.89,824.12,591.89,823.72,590.69,823.12 C591.09,823.12,591.09,823.12,590.69,823.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M617.89,829.52c-3.6-0.2-7-0.6-10.4-1.2C611.09,829.12,614.49,829.52,617.89,829.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M651.49,825.32c1-0.2,1.8-0.6,2.6-1c-7.8,2.6-15.2,4.2-22.4,5C638.09,828.32,644.89,826.92,651.49,825.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M789.09,482.52c-0.2-0.2-0.4-0.4-0.6-0.6l0,0C788.9,482.12,788.9,482.52,789.09,482.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M668.9,818.32c-3,1.4-6,2.6-9,3.6C662.89,820.72,666.09,819.52,668.9,818.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M629.29,829.32c-3.8,0.4-7.6,0.4-11.2,0.4C621.89,829.92,625.69,829.52,629.29,829.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M546.49,755.52l-4.4,2.6c3.2,11.4,7.8,21.2,14,29.4c-0.2-0.6-0.6-1.2-1-1.8 C550.69,776.72,547.89,766.72,546.49,755.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M626.29,526.72c-1.8,2-3.6,4.2-5.4,6.2v9c3.2-3.8,6.4-7.6,9.8-11c16.4-17.4,34.6-32.2,53.4-43 c19-11,37-17,53.4-18.6c1-0.2,2,0,3,0c-3.2-0.4-6.4-0.6-9.8-0.6c-11.6,0-24.4,2.6-37.4,7.8c-4,2-8.2,4-12.2,6.4 C661.89,493.72,643.69,508.72,626.29,526.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M544.09,730.12c0-3.6,0.2-7.2,0.4-10.8l-6.2,3.6c0,2.4-0.2,4.8-0.2,7.2c0,4,0.2,8,0.6,11.8 c0.2,1.2,0.4,2.6,0.6,3.8l5.6-3.2C544.49,738.32,544.09,734.12,544.09,730.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M585.29,592.12c7.2-12.2,15-24,23.4-35.2v-9.8c-8.8,11.2-17.2,23.2-24.8,35.8v11.8 C584.09,594.12,584.49,592.92,585.29,592.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M545.29,749.12l-5,2.8c0.4,2,1,4.2,1.4,6.2l4.4-2.6C546.09,753.32,545.49,751.32,545.29,749.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M620.69,541.92v-9c-2,2.2-4,4.4-6,6.8v9.6C616.49,546.72,618.69,544.32,620.69,541.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M614.89,549.12v-9.6c-2,2.4-4,5-6,7.6v9.8C610.49,554.32,612.7,551.72,614.89,549.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M539.09,745.52c0.4,2.2,0.8,4.2,1.2,6.2l5-2.8c-0.2-2.2-0.4-4.4-0.6-6.6L539.09,745.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M554.89,662.12c4.4-14.8,10.2-29.4,16.8-43.8v-14c-9.4,18.4-17,37-22.6,56c-4.8,16.4-8,32.4-9.6,47.8l6.6-3.8 C547.7,690.52,550.49,676.52,554.89,662.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M577.7,593.12v12.6c2-3.8,4-7.4,6-11.2v-11.8c-1.2,2-2.6,4-3.8,6.2C579.09,590.52,578.69,591.92,577.7,593.12z "
}), React.createElement("path", {
  className: "st1",
  d: "M538.9,715.52c-0.2,2.4-0.2,4.8-0.2,7.2l6.2-3.6c0.2-2.4,0.2-4.8,0.4-7.2L538.9,715.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M546.09,704.32l-6.6,3.8c-0.2,2.4-0.6,5-0.6,7.4l6.4-3.6C545.29,709.32,545.69,706.92,546.09,704.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M571.49,618.32c2-4.2,4-8.4,6-12.4v-12.6c-2,3.8-4.2,7.4-6,11.2V618.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M550.49,790.52c0.4,0.8,0.8,1.4,1.2,2.2c0.2,0,0.4,0.2,0.6,0.2C551.69,792.12,551.29,791.32,550.49,790.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M741.89,463.12c-0.8,0-1.6,0-2.4,0c1,0.2,2,0.2,3,0.4C742.49,463.32,742.29,463.32,741.89,463.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M598.9,537.52c1.6-2.2,3.2-4.2,5-6.2C601.89,533.12,600.29,535.52,598.9,537.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M620.49,511.52c-2,2.2-4,4.4-6,6.6l0,0C616.49,515.92,618.69,513.92,620.49,511.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M610.29,523.32c1.4-1.8,3-3.4,4.6-5.2l0,0c-1.2,1.4-2.6,2.8-3.8,4.2 C610.49,522.92,610.29,522.92,610.29,523.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M590.49,823.12L590.49,823.12L590.49,823.12C590.49,822.92,590.49,823.12,590.49,823.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M782.29,477.72c0.2,0.2,0.4,0.2,0.6,0.4c0.2,0.2,0.4,0.4,0.6,0.4l1.8,1c1.2,0.8,2.2,1.6,3.2,2.4 c-5.4-6.2-11.8-11.4-18.8-15.6c-0.4-0.2-0.8-0.4-1.2-0.6c-3.4-1-7-1.6-10.6-2.2L782.29,477.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M552.49,792.92c-0.2,0-0.4,0-0.6-0.2c0.4,0.6,0.8,1.4,1,2l1.6,1C553.9,794.72,553.09,793.92,552.49,792.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M753.69,465.92c-1-1.2-2-2.2-3-3.2c-2.8-0.2-5.6,0-8.6,0.2c0.2,0.2,0.4,0.2,0.6,0.4 C746.49,463.92,750.09,465.12,753.69,465.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M783.49,478.72c1.8,1,3.4,2.4,5,3.6l0,0c-1.2-0.8-2-1.6-3.2-2.4L783.49,478.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M766.49,471.52c5.4,1.4,10.6,3.4,15.6,6.2l-24.4-14.2c-2.4-0.4-4.8-0.8-7.2-0.8c1,1,2,2.2,3,3.2 C758.09,467.72,762.7,469.32,766.49,471.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M590.49,822.92L590.49,822.92C590.49,823.12,590.69,823.12,590.49,822.92c0.4,0.2,0.4,0.2,0.6,0.2 C591.09,823.12,590.69,822.92,590.49,822.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M693.09,476.32c13.2-5.2,25.8-7.8,37.4-7.8c3.4,0,6.6,0.2,9.8,0.6c2.6-0.2,5-0.2,7.6-0.2 c-1.8-2-3.6-3.8-5.4-5.4c-1-0.2-2-0.2-3-0.4c-1,0-1.8,0-2.8,0C722.7,464.52,708.09,469.32,693.09,476.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M559.89,795.12c-1.4-2.4-2.8-5-4-7.6c-6-8.2-10.8-18-14-29.4l-1.2,0.8c1.8,10.6,4.6,20.6,8.8,29.4 c0.4,0.8,0.8,1.6,1.2,2.4c0.6,0.8,1.2,1.6,1.8,2.4C554.89,793.92,557.49,794.32,559.89,795.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M538.9,741.72c0,1.2,0,2.6,0.2,4l0.4-0.2C538.9,744.32,538.9,742.92,538.9,741.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M539.89,752.12c0.2,2.2,0.6,4.4,1,6.4l1.2-0.8c-0.6-2-1-4-1.4-6.2L539.89,752.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M539.09,745.52l-0.4,0.2c0.2,2.2,0.6,4.4,0.8,6.4l0.6-0.4C540.09,749.92,539.69,747.92,539.09,745.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M559.89,795.12c-2.4-0.6-5-1.2-7.4-2c0.8,1,1.4,2,2.2,2.8l9.8,5.6C562.7,799.12,561.29,797.12,559.89,795.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M756.49,469.52c-1-1.2-1.8-2.4-2.8-3.6c-3.6-1.2-7.2-2-11-2.6c1.8,1.6,3.8,3.4,5.4,5.4 C750.69,468.92,753.69,469.32,756.49,469.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M766.49,471.52c-4.2-2.4-8.6-4.2-13.2-5.6c1,1.2,1.8,2.4,2.8,3.6C759.89,470.12,763.49,470.72,766.49,471.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M774.09,429.92c-1-0.2-2-0.2-3.2-0.4c-23-2.4-49.4,3-77.6,17.6c-4,2.2-8.2,4.4-12.2,6.8 c-3,1.8-5.8,3.6-8.8,5.6c-16,10.6-30.8,23-44,35.6c-2.6,2.6-5.4,5.2-8,8v8.2c1.6-1.6,3-3,4.6-4.6c0.8-1,1.8-1.8,2.6-2.6 c1.4-1.4,2.6-2.6,4-4c9.2-9,18.8-17.2,28.4-24.6c1.6-1.2,3.2-2.4,5-3.6c2.6-1.8,5-3.6,7.6-5.4c21.8-14.8,45.2-25.8,68.4-29.6 c1.6-0.2,3.2-0.4,4.6-0.6c1.6-0.2,3.4-0.4,5-0.6c3-0.2,6.2-0.4,9.2-0.4c0.6,0,1.2,0,1.8,0.2c0.6,0,1.2,0,2,0.2 c3.8,0.2,7.4,0.6,11.2,1.2l0,0c4.2,0.6,8.2,1.8,12.2,3l0,0c3.6,1.2,6.8,2.6,10.2,4.2c0.6,0.2,1.2,0.4,1.8,0.8 c2.8,1.4,6.2,0.4,7.8-2.2c-0.8-0.4-1.4-1-2.2-1.6c-1.4-0.8-2.8-1.6-4.4-2.2c-8-3.8-16-6.4-24.2-7.8 C775.49,430.12,774.89,429.92,774.09,429.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M563.9,851.72c-1.8-1.2-3.4-2.6-5.2-3.8c-2.4-1.8-4.8-3.8-7-6c-1.2-1-2.2-2.2-3.4-3.2c-1.4-1.4-2.8-3-4-4.6 c-1.6-1.8-3-3.8-4.4-6c-0.8-1-1.6-2.2-2.2-3.2c-2.2-3.4-4-7-5.8-10.8c-0.4-1-0.8-2-1.2-3c-1.4-3.2-2.6-6.4-3.6-9.8 c-0.4-1.2-0.8-2.4-1.2-3.6c-1.2-4.2-2.2-8.4-3.2-12.8c0-0.2,0-0.4,0-0.6c-0.4-2.2-0.6-4.4-1-6.6c-0.4-2.2-0.8-4.6-1-6.8l-5.6,3.2 c0.2,2.4,0.6,4.6,1,6.8c0.2,1.8,0.4,3.6,0.8,5.2c0.2,0.6,0.2,1,0.4,1.6c1,4.6,2,8.8,3.4,13c0.4,1.2,0.6,2.2,1,3.4 c3,9.2,6.8,17.4,11.4,24.6c0.8,1.4,1.6,2.6,2.6,3.8c1.4,2,2.8,3.8,4.2,5.6c1.4,1.6,2.6,3.4,4.2,5l0,0c3.8,4,8.2,7.8,12.8,11.2 c2.2,1.6,4.2,3.2,6.6,4.6c0.8,0.4,1.6,0.8,2.4,1.2C567.29,856.92,566.49,853.32,563.9,851.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M519.69,733.72l-5.8,3.4c-0.2,3.6-0.4,7.2-0.4,10.8c0,4.2,0.4,8.2,0.6,12.4l5.8-3.4 C519.09,749.12,519.09,741.72,519.69,733.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M583.9,554.32c7.8-11,16-21.4,24.8-31v-7.4c-1.6,1.8-3,3.4-4.6,5.2c-1.4,1.6-2.6,3.2-4,4.8 c-2.8,3.4-5.4,6.8-8,10.4c-2,2.6-4,5.2-6,8c-0.8,1-1.6,2.2-2.2,3.2V554.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M513.9,766.92c0,0.2,0,0.4,0,0.6c0.2,2,0.6,4,0.8,6l5.6-3.2c-0.2-2.2-0.4-4.4-0.6-6.6L513.9,766.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M616.29,507.52c-0.6,0.6-1,1.2-1.6,1.8v8c2-2,4-4,6-6v-8.2c-0.4,0.6-1,1-1.6,1.6 C618.09,505.32,617.29,506.32,616.29,507.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M608.69,523.72c2-2.2,4-4.4,6-6.4v-8c-2,2.2-4,4.6-6,6.8V523.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M513.9,760.32c0.2,2.2,0.2,4.6,0.4,6.8c0,0,0,0,0,0.2l5.8-3.6c-0.2-2.2-0.2-4.6-0.4-6.8L513.9,760.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M521.09,719.12c0.4-3.6,1-7,1.6-10.6c0-0.2,0-0.4,0.2-0.8c1-5.8,2-11.4,3.4-17.2c0.4-2,1-4.2,1.4-6.2 c0.8-3.4,1.8-6.6,2.6-10c0.4-1.4,0.6-2.8,1-4.2c7.6-33,21.8-66.6,40.6-97v-6.8c-16,25.4-29.8,53.6-40.2,83 c-1.6,4.6-3.2,9.2-4.6,13.8c-0.2,1-0.6,1.8-0.8,2.8c-1.8,6.4-3.6,12.8-5.2,19.2c0,0.2,0,0.2,0,0.4c-3,12.6-5,25.2-6.2,37.4 L521.09,719.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M577.7,563.12c2-3,4-5.8,6-8.6v-6.8c-0.4,0.6-0.8,1-1,1.6c-1.6,2.4-3.4,4.8-5,7.4V563.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M513.9,730.12c-0.2,2.4-0.2,4.8-0.4,7.2l5.8-3.4c0.2-2.4,0.4-4.8,0.6-7.4L513.9,730.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M521.09,719.12l-6.2,3.6c-0.2,2.4-0.6,5-0.6,7.4l6.2-3.6C520.29,723.92,520.49,721.52,521.09,719.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M577.7,563.12v-6.6c-2,3.2-4,6.2-6,9.4v6.8C573.69,569.52,575.49,566.52,577.7,563.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M625.29,506.52c-1.6,1.4-3.2,3-4.6,4.6v0.4C622.29,509.92,623.9,508.32,625.29,506.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M583.9,558.12c4.8-7.2,9.8-14,15-20.8c1.6-2.2,3.2-4.2,5-6.2c1.6-2,3.2-4.2,4.8-6.2v-1.4 c-8.8,9.6-17.2,20-24.8,31V558.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M614.89,518.12c2-2.2,3.8-4.4,6-6.6c0,0,0,0,0-0.2v-0.4c-2,2-4,4-6,6V518.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M608.69,525.12c0.4-0.6,1-1.2,1.6-1.8c0.2-0.2,0.4-0.6,0.8-1c1.2-1.4,2.6-2.8,3.8-4.2v-1c-2,2.2-4,4.2-6,6.4 v1.6H608.69z"
}), React.createElement("path", {
  className: "st1",
  d: "M571.49,577.52v-4.6c-18.8,30.4-33,64-40.6,97c8.4-29,20.8-58.6,37.4-87.2 C569.69,580.72,570.49,579.12,571.49,577.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M577.7,567.72c2-3.2,4-6.2,6-9.2v-3.8c-2,2.8-4,5.8-6,8.6V567.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M571.49,577.52c2-3.4,4-6.6,6-9.8v-4.4c-2,3.2-4,6.4-6,9.6V577.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M543.9,842.72c-1.4-1.6-2.8-3.2-4.2-5C541.09,839.32,542.49,840.92,543.9,842.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M800.29,437.72c-7.4-3.8-15.6-6.4-24.2-7.8C784.29,431.52,792.49,433.92,800.29,437.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M771.09,429.52c1,0.2,2,0.2,3.2,0.4C773.09,429.52,771.89,429.52,771.09,429.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M556.49,853.92c-4.6-3.4-9-7.2-12.8-11.2C547.7,846.92,552.29,850.52,556.49,853.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M683.9,451.92c-0.8,0.6-1.8,1.2-2.6,1.6c4-2.4,8-4.6,12.2-6.8C690.29,448.72,687.29,450.12,683.9,451.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M628.69,494.72c13-12.6,28-25,44-35.6C657.49,469.52,642.7,481.32,628.69,494.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M532.7,828.12c0.8,1.4,1.6,2.6,2.6,3.8C534.49,830.72,533.69,829.32,532.7,828.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M520.29,800.32c0.4,1.2,0.6,2.2,1,3.4C521.09,802.52,520.69,801.52,520.29,800.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M516.69,785.52c-0.4-1.8-0.4-3.6-0.8-5.2c0.4,2.2,0.6,4.6,1.2,6.8C516.89,786.72,516.69,786.32,516.69,785.52z "
}), React.createElement("path", {
  className: "st1",
  d: "M586.09,544.32c2-2.8,4-5.4,6-8C590.09,539.12,587.89,541.72,586.09,544.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M600.09,526.32c1.4-1.6,2.6-3.2,4-4.8C602.7,522.92,601.49,524.32,600.09,526.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M514.09,767.72c0-0.2,0-0.4,0-0.6l0,0C514.09,767.12,514.09,767.52,514.09,767.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M616.29,507.52c1-1,2-2,3-3.2C618.09,505.32,617.29,506.32,616.29,507.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M513.9,766.92L513.9,766.92L513.9,766.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M526.09,665.52c0.2-1,0.4-1.8,0.8-2.8C526.49,663.72,526.49,664.52,526.09,665.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M571.49,565.72c-2.8,4.6-5.8,9-8.4,13.8c-12.8,22.2-23.6,45.8-31.8,69.4 C541.69,619.92,555.69,591.72,571.49,565.72L571.49,565.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M520.69,685.12c0-0.2,0-0.2,0-0.4C521.09,684.72,520.69,685.12,520.69,685.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M582.7,549.12c-1.6,2.4-3.4,4.8-5,7.2v0.2C579.29,554.12,581.09,551.72,582.7,549.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M571.49,565.92c2-3.2,4-6.4,6-9.4v-0.2C575.49,559.52,573.69,562.72,571.49,565.92L571.49,565.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M590.29,823.72c0-0.2,0-0.2,0.2-0.4c-7.8-1.6-15.2-4.2-22-8.2c-0.4-0.2-0.6-0.4-1-0.8 c4.4,4.4,9.2,8.4,14.6,11.4c1,0.6,2,0.8,3,0.8C587.29,826.52,589.09,825.52,590.29,823.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M585.29,820.52l-25-14.4c2.2,3,4.6,5.6,7.2,8.2c0.4,0.2,0.6,0.6,1,0.8c6.8,4,14.2,6.6,22,8.2l0,0 C588.9,822.12,586.89,821.52,585.29,820.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M560.29,801.32c-2-1.8-3.8-3.4-5.6-5.4l-1.6-1c1,1.8,1.8,3.6,3,5.4C557.29,800.52,558.9,800.92,560.29,801.32z "
}), React.createElement("path", {
  className: "st1",
  d: "M590.49,822.92L590.49,822.92c-1.8-1-3.6-1.6-5.4-2.6C586.89,821.52,588.9,822.12,590.49,822.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M560.29,801.32c-1.4-0.2-3-0.8-4.4-1c1.4,2,2.8,4,4.4,5.8l22.6,13l2.4,1.4c-5-2.8-9.4-6.6-13.6-10.8 C567.49,807.12,563.9,804.32,560.29,801.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M560.29,805.92l25,14.4L560.29,805.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M564.09,801.52l-9.8-5.6c1.8,2,3.8,3.8,5.6,5.4c1.4,0.2,3,0.4,4.4,0.6 C564.29,801.72,564.29,801.52,564.09,801.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M564.49,801.72c-1.4-0.2-3-0.2-4.4-0.6c3.6,3.2,7.2,6.2,11.2,8.4C568.9,807.12,566.69,804.52,564.49,801.72z"
}), React.createElement("polygon", {
  className: "st1",
  points: "560.29,805.92 560.29,805.92 585.29,820.52 582.7,819.12  "
}), React.createElement("polygon", {
  className: "st0",
  points: "673.69,660.92 682.29,646.52 620.69,628.92 620.69,645.92  "
}), React.createElement("polygon", {
  className: "st0",
  points: "606.29,641.72 608.69,642.72 608.69,636.72  "
}), React.createElement("polygon", {
  className: "st0",
  points: "620.69,645.92 620.69,628.92 614.89,626.92 614.89,644.12  "
}), React.createElement("polygon", {
  className: "st0",
  points: "614.89,626.92 613.49,626.72 608.69,636.72 608.69,642.72 614.89,644.12  "
}), React.createElement("path", {
  className: "st1",
  d: "M697.89,644.52l-12.4,26.2l-3.2-0.8l-3.2,5.4l4.6,1.4c0.6,0.2,1.2,0.2,1.6,0.2c2.4,0,4.4-1.2,5.4-3.4 l12.6-26.4c0.8-1.6,0.8-3.6,0-5.2c-0.6-1.4-1.8-2.4-3.2-3l-3,5.2L697.89,644.52z"
}), React.createElement("polygon", {
  className: "st1",
  points: "685.29,640.92 688.49,635.52 620.69,616.32 620.69,622.72  "
}), React.createElement("polygon", {
  className: "st1",
  points: "620.69,652.12 620.69,658.72 667.49,671.72 670.49,666.52  "
}), React.createElement("path", {
  className: "st1",
  d: "M604.49,616.92l-12.4,26.2c-0.8,1.6-0.8,3.4,0,5s2.2,2.8,3.8,3.2l12.6,3.6v-6.2l-11-3.2l11-23.2v-8.8 C606.69,614.12,605.29,615.32,604.49,616.92z"
}), React.createElement("polygon", {
  className: "st1",
  points: "614.89,650.52 614.89,656.72 620.69,658.72 620.69,652.12  "
}), React.createElement("polygon", {
  className: "st1",
  points: "620.69,622.72 620.69,616.32 614.89,614.52 614.89,620.72  "
}), React.createElement("polygon", {
  className: "st1",
  points: "608.69,648.92 608.69,655.12 614.89,656.72 614.89,650.52  "
}), React.createElement("path", {
  className: "st1",
  d: "M608.69,613.72v8.8l1.4-3l4.6,1.4v-6.4l-3-0.8C610.49,613.32,609.69,613.32,608.69,613.72z"
}), React.createElement("polygon", {
  className: "st1",
  points: "620.69,645.92 620.69,652.12 670.49,666.52 673.69,660.92  "
}), React.createElement("polygon", {
  className: "st1",
  points: "682.29,646.52 685.29,640.92 620.69,622.72 620.69,628.92  "
}), React.createElement("polygon", {
  className: "st1",
  points: "685.49,670.72 697.89,644.52 697.29,644.32 682.7,670.12  "
}), React.createElement("polygon", {
  className: "st1",
  points: "608.69,648.92 608.69,642.72 606.29,641.72 608.69,636.72 608.69,622.52 597.7,645.52  "
}), React.createElement("polygon", {
  className: "st1",
  points: "614.89,644.12 614.89,650.52 620.69,652.12 620.69,645.92  "
}), React.createElement("polygon", {
  className: "st1",
  points: "620.69,628.92 620.69,622.72 614.89,620.72 614.89,626.92  "
}), React.createElement("polygon", {
  className: "st1",
  points: "613.49,626.72 614.89,626.92 614.89,620.72 610.09,619.32 608.69,622.52 608.69,636.72  "
}), React.createElement("polygon", {
  className: "st1",
  points: "608.69,642.72 608.69,648.92 614.89,650.52 614.89,644.12  "
}), React.createElement("path", {
  className: "st1",
  d: "M700.29,639.12l68.6-119c-0.6-5-1.6-9.8-2.8-14.6c0-0.2,0-0.2,0-0.4c-1.6,0.4-3.2,1.2-4,2.8l-73.6,127.6 l11.2,3.2C699.89,638.92,700.09,639.12,700.29,639.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M660.09,684.72c-1.6,2.8-0.6,6.6,2.2,8.2c1,0.6,2,0.8,3,0.8c2,0,4.2-1,5.2-3l9-15.4l-12-3.4L660.09,684.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M768.9,520.32l3.6-6c1.8-2.8,0.8-6.6-2.2-8.2c-1.2-0.8-2.8-1-4.2-0.6c0,0.2,0,0.2,0,0.4 C767.49,510.12,768.49,515.32,768.9,520.32z"
}), React.createElement("polygon", {
  className: "st1",
  points: "682.49,663.72 689.69,648.32 682.29,646.52 673.69,660.92  "
}), React.createElement("path", {
  className: "st1",
  d: "M697.29,644.32l3-5.2c-0.2,0-0.4-0.2-0.6-0.4l-11.2-3.2l-3.2,5.4L697.29,644.32z"
}), React.createElement("polygon", {
  className: "st1",
  points: "670.49,666.52 667.49,671.72 679.29,675.52 682.7,670.12  "
}), React.createElement("polygon", {
  className: "st1",
  points: "689.69,648.32 682.49,663.72 673.69,660.92 670.49,666.52 682.7,670.12 697.29,644.32 685.29,640.92  682.29,646.52  "
}));

var SvgScheduleIcon = function SvgScheduleIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Livello_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgScheduleIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Schedule_Icon.3d1595c3.svg";
export { ForwardRef as ReactComponent };